import gql from 'graphql-tag';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
};

export type Agent = {
  __typename?: 'Agent';
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_name: Scalars['String']['output'];
};

export type ColorRgb = {
  __typename?: 'ColorRGB';
  b: Scalars['Int']['output'];
  g: Scalars['Int']['output'];
  r: Scalars['Int']['output'];
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  message: Scalars['String']['output'];
  type: MessageResponseType;
};

export type MessageResponseSession = {
  __typename?: 'MessageResponseSession';
  data: MessageResponseSessionData;
  message: Scalars['String']['output'];
  type: MessageResponseType;
};

export type MessageResponseSessionData = {
  __typename?: 'MessageResponseSessionData';
  hasPhone: Scalars['Boolean']['output'];
  requiresMfa: Scalars['Boolean']['output'];
};

export enum MessageResponseType {
  Error = 'error',
  Success = 'success',
  Warning = 'warning'
}

export type Mutation = {
  __typename?: 'Mutation';
  partnerContactRolesUpdate?: Maybe<MessageResponse>;
  portalContactAcceptTermsConditions?: Maybe<PortalContact>;
  /**  Admin mutations  */
  portalContactCreate?: Maybe<PortalContactMessageType>;
  portalContactRequestResetPass?: Maybe<MessageResponse>;
  portalContactSendWelcomeEmail?: Maybe<MessageResponse>;
  portalContactSessionEmailPhoneUpdate?: Maybe<PortalContact>;
  portalContactSessionPasswordUpdate?: Maybe<PortalContact>;
  /**  Session profile mutations  */
  portalContactSessionUpdate?: Maybe<PortalContact>;
  portalContactStatusUpdate?: Maybe<PortalContactMessageType>;
  portalContactUnlock: PortalContact;
  portalContactUpdate?: Maybe<PortalContact>;
  rentersCoverageConfirmationApprove: SnowflakeRentersPolicy;
  rentersCoverageConfirmationAsPending: SnowflakeRentersPolicy;
  rentersCoverageConfirmationReject: SnowflakeRentersPolicy;
  rentersCoverageConfirmationSave: SnowflakeRentersPolicy;
  waiverCategoryContactsUpdate: WaiverCategory;
  waiverCategoryCreate: WaiverCategory;
  waiverCategoryStatusUpdate: WaiverCategory;
  waiverCategoryUpdate: WaiverCategory;
  waiverCategoryUserUpdate: PortalContact;
  waiverContentCreate: WaiverContent;
  waiverContentStatusUpdate: WaiverContent;
  waiverContentUpdate: WaiverContent;
  waiverFormCreate: WaiverForm;
  waiverFormStatusUpdate: WaiverForm;
  waiverFormSubmissionCreate: WaiverFormSubmission;
  waiverFormUpdate: WaiverForm;
  waiverListCreate: WaiverList;
  waiverListStatusUpdate: WaiverList;
  waiverListUpdate: WaiverList;
  waiverQuestionCreate: WaiverQuestion;
  waiverQuestionStatusUpdate: WaiverQuestion;
  waiverQuestionUpdate: WaiverQuestion;
  waiverTemplateCreate: WaiverTemplate;
  waiverTemplateStatusUpdate: WaiverTemplate;
  waiverTemplateUpdate: WaiverTemplate;
  zdTicketCommentCreate?: Maybe<MessageResponse>;
  zdTicketCreate?: Maybe<MessageResponse>;
};


export type MutationPartnerContactRolesUpdateArgs = {
  contactId: Scalars['Int']['input'];
  create?: InputMaybe<Array<Scalars['Int']['input']>>;
  delete?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerId: Scalars['Int']['input'];
};


export type MutationPortalContactCreateArgs = {
  input: PortalContactCreateInput;
  partner_id: Scalars['Int']['input'];
};


export type MutationPortalContactRequestResetPassArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPortalContactSendWelcomeEmailArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPortalContactSessionEmailPhoneUpdateArgs = {
  input: PortalContactSessionEmailPhoneUpdateInput;
};


export type MutationPortalContactSessionPasswordUpdateArgs = {
  input: PortalContactSessionPasswordUpdateInput;
};


export type MutationPortalContactSessionUpdateArgs = {
  input: PortalContactSessionUpdateInput;
};


export type MutationPortalContactStatusUpdateArgs = {
  contact_status: PortalContactStatus;
  id: Scalars['Int']['input'];
  partner_id: Scalars['Int']['input'];
};


export type MutationPortalContactUnlockArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPortalContactUpdateArgs = {
  id: Scalars['Int']['input'];
  input: PortalContactUpdateInput;
};


export type MutationRentersCoverageConfirmationApproveArgs = {
  input: RentersCoverageConfirmationApproveInput;
  partnerId: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationRentersCoverageConfirmationAsPendingArgs = {
  partnerId: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationRentersCoverageConfirmationRejectArgs = {
  partnerId: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};


export type MutationRentersCoverageConfirmationSaveArgs = {
  input: RentersCoverageConfirmationSaveInput;
  partnerId: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationWaiverCategoryContactsUpdateArgs = {
  partner_id: Scalars['Int']['input'];
  portal_contact_ids: Array<Scalars['Int']['input']>;
  uuid: Scalars['String']['input'];
};


export type MutationWaiverCategoryCreateArgs = {
  input: WaiverCategoryInput;
  partner_id: Scalars['Int']['input'];
};


export type MutationWaiverCategoryStatusUpdateArgs = {
  partner_id: Scalars['Int']['input'];
  status: WaiverCategoryStatus;
  uuid: Scalars['String']['input'];
};


export type MutationWaiverCategoryUpdateArgs = {
  input: WaiverCategoryInput;
  partner_id: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationWaiverCategoryUserUpdateArgs = {
  partner_id: Scalars['Int']['input'];
  portal_contact_id: Scalars['Int']['input'];
  waiver_category_uuids: Array<Scalars['String']['input']>;
};


export type MutationWaiverContentCreateArgs = {
  input: WaiverContentInput;
  partner_id: Scalars['Int']['input'];
};


export type MutationWaiverContentStatusUpdateArgs = {
  group_uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  status: WaiverContentStatus;
};


export type MutationWaiverContentUpdateArgs = {
  group_uuid: Scalars['String']['input'];
  input: WaiverContentInput;
  partner_id: Scalars['Int']['input'];
};


export type MutationWaiverFormCreateArgs = {
  input: WaiverFormInput;
  partner_id: Scalars['Int']['input'];
};


export type MutationWaiverFormStatusUpdateArgs = {
  group_uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  status: WaiverFormStatus;
};


export type MutationWaiverFormSubmissionCreateArgs = {
  input: WaiverFormSubmissionInput;
  partner_id: Scalars['Int']['input'];
};


export type MutationWaiverFormUpdateArgs = {
  group_uuid: Scalars['String']['input'];
  input: WaiverFormInput;
  partner_id: Scalars['Int']['input'];
  status?: InputMaybe<WaiverFormStatus>;
};


export type MutationWaiverListCreateArgs = {
  input: WaiverListInput;
  partner_id: Scalars['Int']['input'];
};


export type MutationWaiverListStatusUpdateArgs = {
  partner_id: Scalars['Int']['input'];
  status: WaiverListStatus;
  uuid: Scalars['String']['input'];
};


export type MutationWaiverListUpdateArgs = {
  input: WaiverListInput;
  partner_id: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationWaiverQuestionCreateArgs = {
  input: WaiverQuestionInput;
  partner_id: Scalars['Int']['input'];
};


export type MutationWaiverQuestionStatusUpdateArgs = {
  group_uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  status: WaiverQuestionStatus;
};


export type MutationWaiverQuestionUpdateArgs = {
  group_uuid: Scalars['String']['input'];
  input: WaiverQuestionInput;
  partner_id: Scalars['Int']['input'];
};


export type MutationWaiverTemplateCreateArgs = {
  input: WaiverTemplateInput;
  partner_id: Scalars['Int']['input'];
};


export type MutationWaiverTemplateStatusUpdateArgs = {
  group_uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  status: WaiverTemplateStatus;
};


export type MutationWaiverTemplateUpdateArgs = {
  group_uuid: Scalars['String']['input'];
  input: WaiverTemplateInput;
  partner_id: Scalars['Int']['input'];
  status?: InputMaybe<WaiverTemplateStatus>;
};


export type MutationZdTicketCommentCreateArgs = {
  body: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};


export type MutationZdTicketCreateArgs = {
  body: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export type Partner = {
  __typename?: 'Partner';
  colors: PartnerColors;
  creation_time: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_by_type?: Maybe<Scalars['String']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['String']['output'];
  liability_waiver?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  record_status: Scalars['String']['output'];
  refCodes: Array<RefCode>;
  school: School;
  school_id: Scalars['Int']['output'];
  sessionRights?: Maybe<Array<PartnerRight>>;
  sessionRoles?: Maybe<Array<PartnerRole>>;
  sessionStatus: PortalContactStatus;
  uuid: Scalars['String']['output'];
};

export type PartnerColors = {
  __typename?: 'PartnerColors';
  bg: ColorRgb;
  logoColor: ColorRgb;
  logoOneColor?: Maybe<Scalars['Boolean']['output']>;
  menuFocus: ColorRgb;
  menuHover: ColorRgb;
  menuHoverText: ColorRgb;
  menuSelectedBg: ColorRgb;
  menuSelectedText: ColorRgb;
  menuText: ColorRgb;
  text: ColorRgb;
};

export type PartnerPortalContact = {
  __typename?: 'PartnerPortalContact';
  contact_status: PortalContactStatus;
  id: Scalars['Int']['output'];
  partner: Partner;
  partner_id: Scalars['Int']['output'];
  portal_contact_id: Scalars['Int']['output'];
};

export type PartnerRight = {
  __typename?: 'PartnerRight';
  code: Scalars['String']['output'];
  creation_time: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_by_type?: Maybe<Scalars['String']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['String']['output'];
  name: Scalars['String']['output'];
  record_status: Scalars['String']['output'];
};

export type PartnerRole = {
  __typename?: 'PartnerRole';
  code: Scalars['String']['output'];
  creation_time: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_by_type?: Maybe<Scalars['String']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partner_id?: Maybe<Scalars['Int']['output']>;
  record_status: Scalars['String']['output'];
  rights?: Maybe<Array<PartnerRight>>;
};

/** A paginated list of PartnerRole items. */
export type PartnerRolePaginator = {
  __typename?: 'PartnerRolePaginator';
  /** A list of PartnerRole items. */
  data: Array<PartnerRole>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PartnerRolesSearchInput = {
  partner_id: Scalars['Int']['input'];
};

export type PortalContact = {
  __typename?: 'PortalContact';
  avatar_url?: Maybe<Scalars['String']['output']>;
  creation_time: Scalars['String']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_name: Scalars['String']['output'];
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_by_type?: Maybe<Scalars['String']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['String']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  mfa_expiration_time?: Maybe<Scalars['String']['output']>;
  partnerPortalContact: PartnerPortalContact;
  partnerPortalContactsActive: Array<PartnerPortalContact>;
  partner_id_default?: Maybe<Scalars['Int']['output']>;
  partners: Array<Partner>;
  password?: Maybe<Scalars['String']['output']>;
  portal_contact_status: PortalContactStatus;
  preferred_name?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  record_status: Scalars['String']['output'];
  requiresMfa?: Maybe<Scalars['Boolean']['output']>;
  sessionImpersonation?: Maybe<Scalars['Boolean']['output']>;
  set_pwd_flag?: Maybe<Scalars['Int']['output']>;
  sms_phone?: Maybe<Scalars['String']['output']>;
  terms_and_conditions_acknowledgment_dt?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  waiverCategories: Array<WaiverCategory>;
};


export type PortalContactPartnerPortalContactArgs = {
  partner_id: Scalars['Int']['input'];
};


export type PortalContactWaiverCategoriesArgs = {
  partner_id: Scalars['Int']['input'];
};

export type PortalContactCreateInput = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  preferred_name?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  sms_phone?: InputMaybe<Scalars['String']['input']>;
};

export type PortalContactInput = {
  uuid: Scalars['String']['input'];
};

export type PortalContactMessageType = {
  __typename?: 'PortalContactMessageType';
  data: PortalContact;
  message: Scalars['String']['output'];
  type: MessageResponseType;
};

/** A paginated list of PortalContact items. */
export type PortalContactPaginator = {
  __typename?: 'PortalContactPaginator';
  /** A list of PortalContact items. */
  data: Array<PortalContact>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PortalContactSessionEmailPhoneUpdateInput = {
  sms_phone: Scalars['String']['input'];
};

export type PortalContactSessionPasswordUpdateInput = {
  current_password: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirm: Scalars['String']['input'];
};

export type PortalContactSessionUpdateInput = {
  preferred_name?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
};

export enum PortalContactStatus {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending'
}

export type PortalContactUpdateInput = {
  preferred_name?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  sms_phone?: InputMaybe<Scalars['String']['input']>;
};

export type PortalContactsInput = {
  partner_id: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sms_phone?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  partnerContactRoles?: Maybe<Array<PartnerRole>>;
  partnerRoles: PartnerRolePaginator;
  portalContact?: Maybe<PortalContact>;
  portalContactLogged?: Maybe<PortalContact>;
  portalContacts: PortalContactPaginator;
  refundPolicies?: Maybe<Array<RefundPolicy>>;
  rentersAccountManager?: Maybe<Agent>;
  rentersImplementation?: Maybe<RentersImplementation>;
  rentersImplementations: RentersImplementationPaginator;
  salesRepresentative?: Maybe<Agent>;
  snowflakePolicyRentersCovered?: Maybe<SnowFlakePolicyCovered>;
  snowflakePolicyRentersTrends?: Maybe<SnowFlakePolicyRentersTrends>;
  snowflakePolicyTuitionCovered?: Maybe<SnowFlakeTuitionPolicyCovered>;
  snowflakePolicyTuitionTrends?: Maybe<SnowFlakePolicyTuitionTrends>;
  snowflakeRefundAcknowledgmentVuSearch: SnowFlakeRefundAcknowledgmentVuPaginator;
  snowflakeRentersDecisions: SnowFlakeRentersDecisions;
  snowflakeRentersMonthlyDecisionsPurchase?: Maybe<Array<SnowFlakeRentersMonthlyDecisionsPurchase>>;
  snowflakeRentersPolicies: SnowflakeRentersPolicyPaginator;
  snowflakeRentersPolicy?: Maybe<SnowflakeRentersPolicy>;
  snowflakeTuitionDecisions: SnowFlakeTuitionDecisions;
  snowflakeTuitionMonthlyDecisionsPurchase?: Maybe<Array<SnowFlakeTuitionMonthlyDecisionsPurchase>>;
  snowflakeTuitionPolicies: SnowflakeTuitionPolicyPaginator;
  snowflakeTuitionPolicy?: Maybe<SnowflakeTuitionPolicy>;
  terms: RefCodeTermPaginator;
  tuitionAccountManager?: Maybe<Agent>;
  tuitionImplementations: TuitionImplementationPaginator;
  waiverCategories: WaiverCategoryPaginator;
  waiverCategory?: Maybe<WaiverCategory>;
  waiverCategoryUsers: PortalContactPaginator;
  waiverContent?: Maybe<WaiverContent>;
  waiverContents: WaiverContentPaginator;
  waiverForm?: Maybe<WaiverForm>;
  waiverFormSubmissions: WaiverFormSubmissionPaginator;
  waiverForms: WaiverFormPaginator;
  waiverList?: Maybe<WaiverList>;
  waiverLists: WaiverListPaginator;
  waiverQuestion?: Maybe<WaiverQuestion>;
  waiverQuestions: WaiverQuestionPaginator;
  waiverTemplate?: Maybe<WaiverTemplate>;
  waiverTemplates: WaiverTemplatePaginator;
  zdTicket?: Maybe<ZdTicketUser>;
  zdTicketComments: ZdTicketComments;
  zdTickets: ZdTicketPaginator;
};


export type QueryPartnerContactRolesArgs = {
  contact_id: Scalars['Int']['input'];
  partner_id: Scalars['Int']['input'];
};


export type QueryPartnerRolesArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search: PartnerRolesSearchInput;
};


export type QueryPortalContactArgs = {
  partner_id: Scalars['Int']['input'];
  search: PortalContactInput;
};


export type QueryPortalContactsArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search: PortalContactsInput;
};


export type QueryRefundPoliciesArgs = {
  input?: InputMaybe<RefundPoliciesInput>;
};


export type QueryRentersAccountManagerArgs = {
  partner_id: Scalars['Int']['input'];
};


export type QueryRentersImplementationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRentersImplementationsArgs = {
  first?: Scalars['Int']['input'];
  input: RentersImplementationInput;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySalesRepresentativeArgs = {
  school_id: Scalars['Int']['input'];
};


export type QuerySnowflakePolicyRentersCoveredArgs = {
  input: SnowFlakePolicyStatsInput;
};


export type QuerySnowflakePolicyRentersTrendsArgs = {
  input: SnowFlakePolicyStatsInput;
};


export type QuerySnowflakePolicyTuitionCoveredArgs = {
  input: SnowFlakeTuitionPolicyStatsInput;
};


export type QuerySnowflakePolicyTuitionTrendsArgs = {
  input: SnowFlakeTuitionPolicyStatsInput;
};


export type QuerySnowflakeRefundAcknowledgmentVuSearchArgs = {
  first?: Scalars['Int']['input'];
  input: SnowFlakeRefundAcknowledgementVuSearchInput;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySnowflakeRentersDecisionsArgs = {
  input: SnowFlakeRentersDecisionsInput;
};


export type QuerySnowflakeRentersMonthlyDecisionsPurchaseArgs = {
  input: SnowFlakeRentersDecisionsInput;
};


export type QuerySnowflakeRentersPoliciesArgs = {
  first?: Scalars['Int']['input'];
  input: SnowflakeRentersPolicyInput;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySnowflakeRentersPolicyArgs = {
  end_date?: InputMaybe<Scalars['String']['input']>;
  input: SnowFlakeRentersPolicyInput;
};


export type QuerySnowflakeTuitionDecisionsArgs = {
  input: SnowFlakeTuitionDecisionsInput;
};


export type QuerySnowflakeTuitionMonthlyDecisionsPurchaseArgs = {
  input: SnowFlakeTuitionDecisionsInput;
};


export type QuerySnowflakeTuitionPoliciesArgs = {
  first?: Scalars['Int']['input'];
  input: SnowflakeTuitionPolicyInput;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySnowflakeTuitionPolicyArgs = {
  end_date?: InputMaybe<Scalars['String']['input']>;
  input: SnowFlakeTuitionPolicyInput;
};


export type QueryTermsArgs = {
  first?: Scalars['Int']['input'];
  input: TermsInput;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTuitionAccountManagerArgs = {
  partner_id: Scalars['Int']['input'];
};


export type QueryTuitionImplementationsArgs = {
  first?: Scalars['Int']['input'];
  input: TuitionImplementationInput;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWaiverCategoriesArgs = {
  first?: Scalars['Int']['input'];
  inputGenerated?: InputMaybe<WaiverCategorySearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
  showAllByAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWaiverCategoryArgs = {
  partner_id: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};


export type QueryWaiverCategoryUsersArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search: PortalContactsInput;
};


export type QueryWaiverContentArgs = {
  groupUuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
};


export type QueryWaiverContentsArgs = {
  first?: Scalars['Int']['input'];
  inputGenerated?: InputMaybe<WaiverContentSearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  orderByCategoryName?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
};


export type QueryWaiverFormArgs = {
  groupUuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
};


export type QueryWaiverFormSubmissionsArgs = {
  first?: Scalars['Int']['input'];
  inputGenerated?: InputMaybe<WaiverFormSubmissionSearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  orderByCategoryName?: InputMaybe<SortOrder>;
  orderByFirstName?: InputMaybe<SortOrder>;
  orderByFormName?: InputMaybe<SortOrder>;
  orderByLastName?: InputMaybe<SortOrder>;
  orderByTemplateLabel?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
};


export type QueryWaiverFormsArgs = {
  first?: Scalars['Int']['input'];
  inputGenerated?: InputMaybe<WaiverFormSearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  orderByCategoryName?: InputMaybe<SortOrder>;
  orderByTemplateLabel?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
};


export type QueryWaiverListArgs = {
  partner_id: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};


export type QueryWaiverListsArgs = {
  first?: Scalars['Int']['input'];
  inputGenerated?: InputMaybe<WaiverListSearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
};


export type QueryWaiverQuestionArgs = {
  groupUuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
};


export type QueryWaiverQuestionsArgs = {
  first?: Scalars['Int']['input'];
  inputGenerated?: InputMaybe<WaiverQuestionSearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  orderByCategoryName?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
};


export type QueryWaiverTemplateArgs = {
  groupUuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
};


export type QueryWaiverTemplatesArgs = {
  first?: Scalars['Int']['input'];
  inputGenerated?: InputMaybe<WaiverTemplateSearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  orderByCategoryName?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
};


export type QueryZdTicketArgs = {
  id: Scalars['Int']['input'];
};


export type QueryZdTicketCommentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryZdTicketsArgs = {
  first?: Scalars['Int']['input'];
  input?: InputMaybe<ZdTicketsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type RefCode = {
  __typename?: 'RefCode';
  agent_visible?: Maybe<Scalars['String']['output']>;
  calendar_visible?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  currentRentersImplementation?: Maybe<RentersImplementation>;
  currentTuitionImplementation?: Maybe<TuitionImplementation>;
  id: Scalars['Int']['output'];
  lastTerm?: Maybe<RefCodeTerm>;
  name: Scalars['String']['output'];
  ref_code_status?: Maybe<RefCodeStatus>;
  school?: Maybe<School>;
  school_id?: Maybe<Scalars['Int']['output']>;
  search_visible?: Maybe<Scalars['String']['output']>;
};

export enum RefCodeStatus {
  Active = 'active',
  AgaSetup = 'aga_setup',
  Deleted = 'deleted',
  Inactive = 'inactive',
  New = 'new',
  Qa = 'qa',
  Stub = 'stub'
}

export type RefCodeTerm = {
  __typename?: 'RefCodeTerm';
  id: Scalars['Int']['output'];
  offer_open_date?: Maybe<Scalars['Date']['output']>;
  ref_code_id: Scalars['Int']['output'];
  term_end?: Maybe<Scalars['Date']['output']>;
  term_name: Scalars['String']['output'];
  term_start?: Maybe<Scalars['Date']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of RefCodeTerm items. */
export type RefCodeTermPaginator = {
  __typename?: 'RefCodeTermPaginator';
  /** A list of RefCodeTerm items. */
  data: Array<RefCodeTerm>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type RefundPoliciesInput = {
  partner_id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type RefundPolicy = {
  __typename?: 'RefundPolicy';
  created_by?: Maybe<Scalars['Int']['output']>;
  created_by_type?: Maybe<Scalars['String']['output']>;
  creation_time?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_by_type?: Maybe<Scalars['String']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time?: Maybe<Scalars['DateTime']['output']>;
  record_status?: Maybe<Scalars['String']['output']>;
  refund_policy_content: Scalars['String']['output'];
  refund_policy_status: Scalars['String']['output'];
  renters_implementation_id?: Maybe<Scalars['Int']['output']>;
  tuition_implementation_id?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};

export type RefundPolicyFlow = {
  __typename?: 'RefundPolicyFlow';
  date: Scalars['String']['output'];
  description: Scalars['String']['output'];
  refund_policy_id: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type RentersCoverageConfirmationApproveInput = {
  confirmation_note?: InputMaybe<Scalars['String']['input']>;
  coverage_end_date?: InputMaybe<Scalars['String']['input']>;
  coverage_start_date: Scalars['String']['input'];
  deductible: Scalars['Int']['input'];
  insurance_carrier: Scalars['String']['input'];
  insurance_type: Scalars['String']['input'];
  liability_coverage: Scalars['Int']['input'];
  policy_number: Scalars['String']['input'];
  property_coverage: Scalars['Int']['input'];
};

export type RentersCoverageConfirmationSaveInput = {
  confirmation_note?: InputMaybe<Scalars['String']['input']>;
  coverage_end_date?: InputMaybe<Scalars['String']['input']>;
  coverage_start_date?: InputMaybe<Scalars['String']['input']>;
  deductible?: InputMaybe<Scalars['Int']['input']>;
  insurance_carrier: Scalars['String']['input'];
  insurance_type: Scalars['String']['input'];
  liability_coverage?: InputMaybe<Scalars['Int']['input']>;
  policy_number: Scalars['String']['input'];
  property_coverage?: InputMaybe<Scalars['Int']['input']>;
};

export type RentersImplementation = {
  __typename?: 'RentersImplementation';
  default_liability_coverage?: Maybe<Scalars['Int']['output']>;
  default_property_coverage?: Maybe<Scalars['Int']['output']>;
  effective_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  min_liability_coverage?: Maybe<Scalars['Int']['output']>;
  min_property_coverage?: Maybe<Scalars['Int']['output']>;
  ref_code_id: Scalars['Int']['output'];
  season: Scalars['String']['output'];
  start_date?: Maybe<Scalars['String']['output']>;
  term: Scalars['String']['output'];
};

export type RentersImplementationInput = {
  effective_date_max?: InputMaybe<Scalars['String']['input']>;
  partner_id: Scalars['Int']['input'];
};

/** A paginated list of RentersImplementation items. */
export type RentersImplementationPaginator = {
  __typename?: 'RentersImplementationPaginator';
  /** A list of RentersImplementation items. */
  data: Array<RentersImplementation>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type School = {
  __typename?: 'School';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  address_city: Scalars['String']['output'];
  address_country: Scalars['String']['output'];
  address_state: Scalars['String']['output'];
  address_zip: Scalars['String']['output'];
  erp_code?: Maybe<Scalars['String']['output']>;
  hasRentersCoverageConfirmationLite: Scalars['Boolean']['output'];
  hasRentersCoverageConfirmationPro: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  logo_url?: Maybe<Scalars['String']['output']>;
  primaryRefCode?: Maybe<RefCode>;
  renters_contract_id?: Maybe<Scalars['String']['output']>;
  sales_rep_agent_id?: Maybe<Scalars['Int']['output']>;
  school_name: Scalars['String']['output'];
  tuition_contract_id?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

export type SnowFlakePolicyCovered = {
  __typename?: 'SnowFlakePolicyCovered';
  activeInRange: Scalars['Int']['output'];
  range_purchases: Scalars['Int']['output'];
  range_status_active: Scalars['Int']['output'];
  range_status_other: Scalars['Int']['output'];
  range_status_pending: Scalars['Int']['output'];
  schoolCapacity: Scalars['Int']['output'];
  school_id: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum SnowFlakePolicyRangePurchaseByEnum {
  Student = 'student',
  Unknown = 'unknown',
  User = 'user'
}

export enum SnowFlakePolicyRangeStatusEnum {
  Active = 'active',
  Approved = 'approved',
  Cancelled = 'cancelled',
  Expired = 'expired',
  GgReview = 'gg_review',
  NeedsReview = 'needs_review',
  NeedsReviewExpired = 'needs_review_expired',
  Pending = 'pending',
  Processed = 'processed',
  Rejected = 'rejected',
  Submitted = 'submitted',
  Suspended = 'suspended',
  Unknown = 'unknown'
}

export type SnowFlakePolicyRentersTrends = {
  __typename?: 'SnowFlakePolicyRentersTrends';
  DEDUCTIBLE: Scalars['Int']['output'];
  EARTHQUAKE: Scalars['Int']['output'];
  LIABILITY: Scalars['Int']['output'];
  POLICIES: Scalars['Int']['output'];
  PROPERTY: Scalars['Int']['output'];
  TOTAL: Scalars['Float']['output'];
};

/**  Stats  */
export type SnowFlakePolicyStatsInput = {
  end_date: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  start_date: Scalars['String']['input'];
};

export type SnowFlakePolicyTuitionTrends = {
  __typename?: 'SnowFlakePolicyTuitionTrends';
  AVERAGE: Scalars['Int']['output'];
  POLICIES: Scalars['Int']['output'];
  TOTAL: Scalars['Int']['output'];
};

export type SnowFlakeRefundAcknowledgementVuSearchInput = {
  end_date: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  season?: InputMaybe<Scalars['String']['input']>;
  start_date: Scalars['String']['input'];
  student_id?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type SnowFlakeRefundAcknowledgmentVu = {
  __typename?: 'SnowFlakeRefundAcknowledgmentVu';
  ENROLLMENT_DATE?: Maybe<Scalars['String']['output']>;
  MOST_RECENT_ACKNOWLEDGEMENT?: Maybe<Scalars['String']['output']>;
  MOST_RECENT_ACKNOWLEDGEMENT_TIME?: Maybe<Scalars['String']['output']>;
  MOST_RECENT_REFUND_POLICY_CONTENT?: Maybe<Scalars['String']['output']>;
  POLICY_NUMBER?: Maybe<Scalars['String']['output']>;
  QUICK_USER_ID?: Maybe<Scalars['Int']['output']>;
  QU_POLICY_NUMBER?: Maybe<Scalars['String']['output']>;
  STUDENT_EMAIL?: Maybe<Scalars['String']['output']>;
  STUDENT_FIRST_NAME?: Maybe<Scalars['String']['output']>;
  STUDENT_ID?: Maybe<Scalars['String']['output']>;
  STUDENT_LAST_NAME?: Maybe<Scalars['String']['output']>;
  STUDENT_NAME?: Maybe<Scalars['String']['output']>;
  WHO_HAS_ACKNOWLEDGED?: Maybe<Scalars['String']['output']>;
  combinedRefundPolicyFlow?: Maybe<Array<RefundPolicyFlow>>;
};

/** A paginated list of SnowFlakeRefundAcknowledgmentVu items. */
export type SnowFlakeRefundAcknowledgmentVuPaginator = {
  __typename?: 'SnowFlakeRefundAcknowledgmentVuPaginator';
  /** A list of SnowFlakeRefundAcknowledgmentVu items. */
  data: Array<SnowFlakeRefundAcknowledgmentVu>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SnowFlakeRentersDecisions = {
  __typename?: 'SnowFlakeRentersDecisions';
  billmelater: Scalars['Int']['output'];
  decline: Scalars['Int']['output'];
  none: Scalars['Int']['output'];
  purchase: Scalars['Int']['output'];
  remindmelater: Scalars['Int']['output'];
  renewal: Scalars['Int']['output'];
};

export type SnowFlakeRentersDecisionsInput = {
  end_date: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  start_date: Scalars['String']['input'];
};

export type SnowFlakeRentersMonthlyDecisionsPurchase = {
  __typename?: 'SnowFlakeRentersMonthlyDecisionsPurchase';
  id: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  purchased: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export enum SnowFlakeRentersPoliciesRangeDbStatusEnum {
  Active = 'active',
  Approved = 'approved',
  Cancelled = 'cancelled',
  Expired = 'expired',
  GgReview = 'gg_review',
  Pending = 'pending',
  PermSuspended = 'permSuspended',
  PreCancelled = 'preCancelled',
  Preactive = 'preactive',
  Processed = 'processed',
  Rejected = 'rejected',
  Submitted = 'submitted',
  Suspended = 'suspended'
}

export type SnowFlakeRentersPolicyInput = {
  policy_number: Scalars['String']['input'];
};

export type SnowFlakeTuitionDecisions = {
  __typename?: 'SnowFlakeTuitionDecisions';
  accept: Scalars['Int']['output'];
  decline: Scalars['Int']['output'];
  purchase: Scalars['Int']['output'];
  remindmelater: Scalars['Int']['output'];
};

export type SnowFlakeTuitionDecisionsInput = {
  end_date: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  start_date: Scalars['String']['input'];
};

export type SnowFlakeTuitionMonthlyDecisionsPurchase = {
  __typename?: 'SnowFlakeTuitionMonthlyDecisionsPurchase';
  id: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  purchased: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type SnowFlakeTuitionPolicyCovered = {
  __typename?: 'SnowFlakeTuitionPolicyCovered';
  activeInRange: Scalars['Int']['output'];
  range_purchases: Scalars['Int']['output'];
  range_status_active: Scalars['Int']['output'];
  range_status_other: Scalars['Int']['output'];
  range_status_pending: Scalars['Int']['output'];
  schoolCapacity: Scalars['Int']['output'];
  school_id: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SnowFlakeTuitionPolicyInput = {
  policy_number: Scalars['String']['input'];
};

/**  Stats  */
export type SnowFlakeTuitionPolicyStatsInput = {
  end_date: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  start_date: Scalars['String']['input'];
};

export type SnowflakeRentersPolicy = {
  __typename?: 'SnowflakeRentersPolicy';
  CANCELLATION_DATE?: Maybe<Scalars['String']['output']>;
  CANCELLATION_REASON?: Maybe<Scalars['String']['output']>;
  CANCELLATION_SOURCE?: Maybe<Scalars['String']['output']>;
  CONFIRMATION_NOTE?: Maybe<Scalars['String']['output']>;
  COVERAGE_END_DATE: Scalars['String']['output'];
  COVERAGE_END_DATE_OR_AUTO_RENEW?: Maybe<Scalars['String']['output']>;
  COVERAGE_START_DATE: Scalars['String']['output'];
  CREATED_BY?: Maybe<Scalars['Int']['output']>;
  CREATED_BY_TYPE?: Maybe<Scalars['String']['output']>;
  DEDUCTIBLE?: Maybe<Scalars['Int']['output']>;
  EARTHQUAKE_COVERAGE: Scalars['Int']['output'];
  ENROLLMENT_DATE?: Maybe<Scalars['String']['output']>;
  FILE_EXT?: Maybe<Scalars['String']['output']>;
  FILE_ID?: Maybe<Scalars['Int']['output']>;
  INSURANCE_CARRIER: Scalars['String']['output'];
  INSURANCE_TYPE?: Maybe<Scalars['String']['output']>;
  IS_AUTO_RENEW: Scalars['Boolean']['output'];
  IS_FLAT_CANCEL: Scalars['Boolean']['output'];
  LAST_UPDATE_BY?: Maybe<Scalars['Int']['output']>;
  LAST_UPDATE_BY_TYPE?: Maybe<Scalars['String']['output']>;
  LAST_UPDATE_TIME?: Maybe<Scalars['String']['output']>;
  LIABILITY_COVERAGE?: Maybe<Scalars['Int']['output']>;
  ON_CAMPUS: Scalars['Boolean']['output'];
  PAYMENT_INTERVAL: Scalars['Int']['output'];
  POLICY_CREATION_TIME: Scalars['String']['output'];
  POLICY_ID: Scalars['String']['output'];
  POLICY_NUMBER: Scalars['String']['output'];
  POLICY_SOURCE?: Maybe<Scalars['String']['output']>;
  POLICY_STATUS: SnowFlakeRentersPoliciesRangeDbStatusEnum;
  POLICY_STATUS_TODAY: SnowFlakeRentersPoliciesRangeDbStatusEnum;
  PRIMARY_INSURED_ADDRESS?: Maybe<Scalars['String']['output']>;
  PRIMARY_INSURED_CITY?: Maybe<Scalars['String']['output']>;
  PRIMARY_INSURED_STATE?: Maybe<Scalars['String']['output']>;
  PRIMARY_INSURED_ZIP?: Maybe<Scalars['String']['output']>;
  PROPERTY_COVERAGE?: Maybe<Scalars['Int']['output']>;
  PURCHASE_BY?: Maybe<SnowFlakePolicyRangePurchaseByEnum>;
  REF_CODE: Scalars['String']['output'];
  RENTERS_IMPLEMENTATION_ID?: Maybe<Scalars['Int']['output']>;
  SCHOOL_ID: Scalars['Int']['output'];
  SCHOOL_NAME: Scalars['String']['output'];
  STUDENT_EMAIL: Scalars['String']['output'];
  STUDENT_EXTERNAL_ID?: Maybe<Scalars['String']['output']>;
  STUDENT_FIRST_NAME: Scalars['String']['output'];
  STUDENT_LAST_NAME: Scalars['String']['output'];
  STUDENT_NAME: Scalars['String']['output'];
  STUDENT_PHONE?: Maybe<Scalars['String']['output']>;
  lastUpdateBy?: Maybe<UpdateByUser>;
  rangeStatus: SnowFlakePolicyRangeStatusEnum;
};


export type SnowflakeRentersPolicyRangeStatusArgs = {
  end_date: Scalars['String']['input'];
};

export type SnowflakeRentersPolicyInput = {
  activeInRange?: InputMaybe<Scalars['Boolean']['input']>;
  end_date: Scalars['String']['input'];
  entity?: InputMaybe<Scalars['String']['input']>;
  partner_id: Scalars['Int']['input'];
  purchaseInRange?: InputMaybe<Scalars['Boolean']['input']>;
  rangeStatus?: InputMaybe<Array<SnowFlakePolicyRangeStatusEnum>>;
  start_date: Scalars['String']['input'];
};

/** A paginated list of SnowflakeRentersPolicy items. */
export type SnowflakeRentersPolicyPaginator = {
  __typename?: 'SnowflakeRentersPolicyPaginator';
  /** A list of SnowflakeRentersPolicy items. */
  data: Array<SnowflakeRentersPolicy>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SnowflakeTuitionPolicy = {
  __typename?: 'SnowflakeTuitionPolicy';
  ACCOUNT_HOLDER_EMAIL?: Maybe<Scalars['String']['output']>;
  ACCOUNT_OWNER_NAME?: Maybe<Scalars['String']['output']>;
  ACCOUNT_OWNER_PHONE?: Maybe<Scalars['String']['output']>;
  AMOUNT_PAID?: Maybe<Scalars['Float']['output']>;
  AMOUNT_REFUNDED?: Maybe<Scalars['Float']['output']>;
  CALENDAR_TERM?: Maybe<Scalars['String']['output']>;
  CANCELLATION_DATE?: Maybe<Scalars['String']['output']>;
  CANCELLATION_REASON?: Maybe<Scalars['String']['output']>;
  CANCELLATION_SOURCE?: Maybe<Scalars['String']['output']>;
  CHARGE_DATE?: Maybe<Scalars['String']['output']>;
  COVERAGE_AMOUNT: Scalars['Int']['output'];
  DAYS_BEFORE_TERM_START?: Maybe<Scalars['Int']['output']>;
  DAYS_COVERED?: Maybe<Scalars['Int']['output']>;
  DAYS_SINCE_BILL_DATE?: Maybe<Scalars['Int']['output']>;
  DAYS_SINCE_BILL_DATE_DUE?: Maybe<Scalars['Int']['output']>;
  DAYS_SINCE_OFFER_OPEN?: Maybe<Scalars['Int']['output']>;
  END_DATE: Scalars['String']['output'];
  ENROLLMENT_DATE?: Maybe<Scalars['String']['output']>;
  ENTITY_ID?: Maybe<Scalars['Int']['output']>;
  IMPLEMENTATION_SEASON?: Maybe<Scalars['String']['output']>;
  IMPLEMENTATION_TERM?: Maybe<Scalars['String']['output']>;
  INSURED_ADDRESS: Scalars['String']['output'];
  INSURED_CITY: Scalars['String']['output'];
  INSURED_EMAIL: Scalars['String']['output'];
  INSURED_EXTERNAL_ID?: Maybe<Scalars['String']['output']>;
  INSURED_FIRST_NAME: Scalars['String']['output'];
  INSURED_LAST_NAME: Scalars['String']['output'];
  INSURED_NAME: Scalars['String']['output'];
  INSURED_PHONE?: Maybe<Scalars['String']['output']>;
  INSURED_STATE: Scalars['String']['output'];
  INSURED_ZIP: Scalars['String']['output'];
  IS_FLAT_CANCEL?: Maybe<Scalars['Boolean']['output']>;
  IS_ON_CAMPUS: Scalars['Boolean']['output'];
  IS_PAID?: Maybe<Scalars['Boolean']['output']>;
  IS_PURCHASED_BY_STUDENT?: Maybe<Scalars['Boolean']['output']>;
  IS_REFUNDED?: Maybe<Scalars['Boolean']['output']>;
  MEMBERSHIP_ID?: Maybe<Scalars['Int']['output']>;
  NUM_REFUNDS?: Maybe<Scalars['Int']['output']>;
  OFFER_OPEN_DATE?: Maybe<Scalars['String']['output']>;
  PAYMENT_GATEWAY?: Maybe<Scalars['String']['output']>;
  PAYMENT_STATUS?: Maybe<Scalars['String']['output']>;
  PAYMENT_TRANSACTION_ID?: Maybe<Scalars['Int']['output']>;
  POLICY_CREATION_TIME?: Maybe<Scalars['String']['output']>;
  POLICY_ID: Scalars['Int']['output'];
  POLICY_NUMBER: Scalars['String']['output'];
  POLICY_SOURCE?: Maybe<Scalars['String']['output']>;
  POLICY_STATUS?: Maybe<SnowflakeTuitionRangeDbStatusEnum>;
  PRICE?: Maybe<Scalars['Float']['output']>;
  PROGRAM_TYPE?: Maybe<Scalars['String']['output']>;
  REFUND_MORE_THAN_PRICE?: Maybe<Scalars['Boolean']['output']>;
  REFUND_TIME?: Maybe<Scalars['String']['output']>;
  REF_CODE?: Maybe<Scalars['String']['output']>;
  SCHOOL_ID?: Maybe<Scalars['Int']['output']>;
  SCHOOL_NAME?: Maybe<Scalars['String']['output']>;
  START_DATE: Scalars['String']['output'];
  TERM_AND_SEASON?: Maybe<Scalars['String']['output']>;
  TERM_GOAL_ASSIGNED_TO?: Maybe<Scalars['String']['output']>;
  TUITION_IMPLEMENTATION_ID?: Maybe<Scalars['Int']['output']>;
  YEARLY_GOAL_ASSIGNED_TO?: Maybe<Scalars['String']['output']>;
  rangeStatus: SnowflakeTuitionRangeStatusEnum;
};


export type SnowflakeTuitionPolicyRangeStatusArgs = {
  end_date: Scalars['String']['input'];
};

export type SnowflakeTuitionPolicyInput = {
  activeInRange?: InputMaybe<Scalars['Boolean']['input']>;
  end_date: Scalars['String']['input'];
  entity?: InputMaybe<Scalars['String']['input']>;
  partner_id: Scalars['Int']['input'];
  purchaseInRange?: InputMaybe<Scalars['Boolean']['input']>;
  rangeStatus?: InputMaybe<Array<SnowflakeTuitionRangeStatusEnum>>;
  start_date: Scalars['String']['input'];
};

/** A paginated list of SnowflakeTuitionPolicy items. */
export type SnowflakeTuitionPolicyPaginator = {
  __typename?: 'SnowflakeTuitionPolicyPaginator';
  /** A list of SnowflakeTuitionPolicy items. */
  data: Array<SnowflakeTuitionPolicy>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum SnowflakeTuitionRangeDbStatusEnum {
  Active = 'active',
  Cancelled = 'cancelled',
  Expired = 'expired',
  Inactive = 'inactive',
  PaymentFailed = 'paymentFailed',
  Pending = 'pending',
  PermSuspended = 'permSuspended',
  Preactive = 'preactive',
  StuckPolicy = 'stuck_policy'
}

export enum SnowflakeTuitionRangeStatusEnum {
  Active = 'active',
  Cancelled = 'cancelled',
  Expired = 'expired',
  Pending = 'pending',
  Unknown = 'unknown'
}

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export enum TermTypesEnum {
  Annual = 'annual',
  Fall = 'fall',
  Jterm = 'jterm',
  May = 'may',
  Spring = 'spring',
  Summer = 'summer',
  Winter = 'winter'
}

export type TermsInput = {
  partner_id: Scalars['Int']['input'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type TuitionImplementation = {
  __typename?: 'TuitionImplementation';
  effective_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  payment_gateway?: Maybe<Scalars['String']['output']>;
  ref_code_id: Scalars['Int']['output'];
  season: Scalars['String']['output'];
  term: Scalars['String']['output'];
};

export type TuitionImplementationInput = {
  effective_date_max?: InputMaybe<Scalars['String']['input']>;
  partner_id: Scalars['Int']['input'];
};

/** A paginated list of TuitionImplementation items. */
export type TuitionImplementationPaginator = {
  __typename?: 'TuitionImplementationPaginator';
  /** A list of TuitionImplementation items. */
  data: Array<TuitionImplementation>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UpdateByUser = {
  __typename?: 'UpdateByUser';
  first_name: Scalars['String']['output'];
  id: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
};

export type WaiverCategory = {
  __typename?: 'WaiverCategory';
  desc?: Maybe<Scalars['String']['output']>;
  is_editable: Scalars['Boolean']['output'];
  is_global: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  partner_id: Scalars['Int']['output'];
  portal_contact_ids: Array<Scalars['Int']['output']>;
  status: WaiverCategoryStatus;
  total_users: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type WaiverCategoryInput = {
  desc: Scalars['String']['input'];
  name: Scalars['String']['input'];
  portal_contact_ids: Array<Scalars['Int']['input']>;
};

/** A paginated list of WaiverCategory items. */
export type WaiverCategoryPaginator = {
  __typename?: 'WaiverCategoryPaginator';
  /** A list of WaiverCategory items. */
  data: Array<WaiverCategory>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type WaiverCategorySearchInputGenerated = {
  name?: InputMaybe<Scalars['String']['input']>;
  nameOperator?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusOperator?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuidOperator?: InputMaybe<Scalars['String']['input']>;
};

export enum WaiverCategoryStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type WaiverContent = {
  __typename?: 'WaiverContent';
  created_by?: Maybe<Scalars['Int']['output']>;
  created_by_name?: Maybe<Scalars['String']['output']>;
  created_by_type?: Maybe<Scalars['String']['output']>;
  creation_time: Scalars['DateTime']['output'];
  group_uuid: Scalars['String']['output'];
  html: Scalars['String']['output'];
  label: Scalars['String']['output'];
  last_interaction_by_name?: Maybe<Scalars['String']['output']>;
  last_interaction_by_type?: Maybe<Scalars['String']['output']>;
  last_interaction_time: Scalars['DateTime']['output'];
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_by_type?: Maybe<Scalars['String']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['DateTime']['output'];
  record_status: Scalars['String']['output'];
  status: WaiverContentStatus;
  uuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  waiver_category_uuid: Scalars['String']['output'];
};

export type WaiverContentInput = {
  html: Scalars['String']['input'];
  label: Scalars['String']['input'];
  waiver_category_uuid: Scalars['String']['input'];
};

/** A paginated list of WaiverContent items. */
export type WaiverContentPaginator = {
  __typename?: 'WaiverContentPaginator';
  /** A list of WaiverContent items. */
  data: Array<WaiverContent>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type WaiverContentSearchInputGenerated = {
  groupUuid?: InputMaybe<Scalars['String']['input']>;
  groupUuidOperator?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  labelOperator?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusOperator?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuidOperator?: InputMaybe<Scalars['String']['input']>;
  waiverCategoryUuid?: InputMaybe<Array<Scalars['String']['input']>>;
  waiverCategoryUuidOperator?: InputMaybe<Scalars['String']['input']>;
};

export enum WaiverContentStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type WaiverForm = {
  __typename?: 'WaiverForm';
  created_by?: Maybe<Scalars['Int']['output']>;
  created_by_name?: Maybe<Scalars['String']['output']>;
  created_by_type?: Maybe<Scalars['String']['output']>;
  creation_time: Scalars['DateTime']['output'];
  currentTemplate?: Maybe<WaiverTemplate>;
  displayStatus: WaiverFormDisplayStatus;
  fields: Array<WaiverFormField>;
  group_uuid: Scalars['String']['output'];
  last_interaction_by_name?: Maybe<Scalars['String']['output']>;
  last_interaction_by_type?: Maybe<Scalars['String']['output']>;
  last_interaction_time: Scalars['DateTime']['output'];
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_by_type?: Maybe<Scalars['String']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['DateTime']['output'];
  live_end_date: Scalars['Date']['output'];
  live_start_date: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  record_status: Scalars['String']['output'];
  status: WaiverFormStatus;
  submissions_count: Scalars['Int']['output'];
  template: WaiverTemplate;
  uuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  waiver_template_uuid: Scalars['String']['output'];
};

export enum WaiverFormDisplayStatus {
  Archived = 'Archived',
  Closed = 'Closed',
  Draft = 'Draft',
  Open = 'Open',
  Upcoming = 'Upcoming'
}

export type WaiverFormField = {
  __typename?: 'WaiverFormField';
  creation_time: Scalars['DateTime']['output'];
  format?: Maybe<Scalars['String']['output']>;
  group_uuid: Scalars['String']['output'];
  last_update_time: Scalars['DateTime']['output'];
  templateItemField: WaiverTemplateItemField;
  uuid: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
  waiver_form_uuid: Scalars['String']['output'];
  waiver_template_item_field_uuid: Scalars['String']['output'];
};

export type WaiverFormFieldInput = {
  format?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  waiver_template_item_field_uuid: Scalars['String']['input'];
};

export type WaiverFormInput = {
  fields?: InputMaybe<Array<WaiverFormFieldInput>>;
  live_end_date: Scalars['Date']['input'];
  live_start_date: Scalars['Date']['input'];
  name: Scalars['String']['input'];
  waiver_template_uuid: Scalars['String']['input'];
};

/** A paginated list of WaiverForm items. */
export type WaiverFormPaginator = {
  __typename?: 'WaiverFormPaginator';
  /** A list of WaiverForm items. */
  data: Array<WaiverForm>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type WaiverFormSearchInputGenerated = {
  groupUuid?: InputMaybe<Scalars['String']['input']>;
  groupUuidOperator?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOperator?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<WaiverFormStatus>>;
  statusOperator?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuidOperator?: InputMaybe<Scalars['String']['input']>;
  waiverCategoryUuid?: InputMaybe<Array<Scalars['String']['input']>>;
  waiverCategoryUuidOperator?: InputMaybe<Scalars['String']['input']>;
  waiverTemplateUuid?: InputMaybe<Array<Scalars['String']['input']>>;
  waiverTemplateUuidOperator?: InputMaybe<Scalars['String']['input']>;
};

export enum WaiverFormStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

export type WaiverFormSubmission = {
  __typename?: 'WaiverFormSubmission';
  creation_time: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  form: WaiverForm;
  form_uuid: Scalars['String']['output'];
  is_test: Scalars['Boolean']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['DateTime']['output'];
  questions: Array<WaiverFormSubmissionQuestion>;
  record_status: Scalars['String']['output'];
  student_id?: Maybe<Scalars['String']['output']>;
  submitted_at: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type WaiverFormSubmissionInput = {
  form_uuid: Scalars['String']['input'];
  questions?: InputMaybe<Array<WaiverFormSubmissionQuestionInput>>;
};

/** A paginated list of WaiverFormSubmission items. */
export type WaiverFormSubmissionPaginator = {
  __typename?: 'WaiverFormSubmissionPaginator';
  /** A list of WaiverFormSubmission items. */
  data: Array<WaiverFormSubmission>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type WaiverFormSubmissionQuestion = {
  __typename?: 'WaiverFormSubmissionQuestion';
  answered?: Maybe<Scalars['String']['output']>;
  creation_time: Scalars['DateTime']['output'];
  form_submission_uuid: Scalars['String']['output'];
  last_update_time: Scalars['DateTime']['output'];
  question_uuid: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type WaiverFormSubmissionQuestionInput = {
  answered?: InputMaybe<Scalars['String']['input']>;
  question_uuid: Scalars['String']['input'];
};

export type WaiverFormSubmissionSearchInputGenerated = {
  signer?: InputMaybe<Scalars['String']['input']>;
  signerOperator?: InputMaybe<Scalars['String']['input']>;
  tests?: InputMaybe<Scalars['Boolean']['input']>;
  waiverCategoryUuid?: InputMaybe<Array<Scalars['String']['input']>>;
  waiverCategoryUuidOperator?: InputMaybe<Scalars['String']['input']>;
  waiverFormGroupUuid?: InputMaybe<Array<Scalars['String']['input']>>;
  waiverFormGroupUuidOperator?: InputMaybe<Scalars['String']['input']>;
  waiverTemplateUuid?: InputMaybe<Array<Scalars['String']['input']>>;
  waiverTemplateUuidOperator?: InputMaybe<Scalars['String']['input']>;
};

export type WaiverList = {
  __typename?: 'WaiverList';
  activeOptions: Array<WaiverListOption>;
  created_by?: Maybe<Scalars['Int']['output']>;
  created_by_type?: Maybe<Scalars['String']['output']>;
  creation_time: Scalars['DateTime']['output'];
  label: Scalars['String']['output'];
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_by_type?: Maybe<Scalars['String']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['DateTime']['output'];
  options: Array<WaiverListOption>;
  partner_id: Scalars['Int']['output'];
  questions: Array<WaiverQuestion>;
  record_status: Scalars['String']['output'];
  status: WaiverListStatus;
  uuid: Scalars['String']['output'];
};

export type WaiverListInput = {
  label: Scalars['String']['input'];
  options?: InputMaybe<Array<WaiverListOptionInput>>;
  status?: InputMaybe<WaiverListStatus>;
};

export type WaiverListOption = {
  __typename?: 'WaiverListOption';
  creation_time: Scalars['DateTime']['output'];
  label: Scalars['String']['output'];
  last_update_time: Scalars['DateTime']['output'];
  sort_order: Scalars['Int']['output'];
  status: WaiverListStatus;
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
  waiver_list_uuid: Scalars['String']['output'];
};

export type WaiverListOptionInput = {
  label: Scalars['String']['input'];
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<WaiverListStatus>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** A paginated list of WaiverList items. */
export type WaiverListPaginator = {
  __typename?: 'WaiverListPaginator';
  /** A list of WaiverList items. */
  data: Array<WaiverList>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type WaiverListSearchInputGenerated = {
  label?: InputMaybe<Scalars['String']['input']>;
  labelOperator?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusOperator?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuidOperator?: InputMaybe<Scalars['String']['input']>;
};

export enum WaiverListStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type WaiverQuestion = {
  __typename?: 'WaiverQuestion';
  created_by?: Maybe<Scalars['Int']['output']>;
  created_by_type?: Maybe<Scalars['String']['output']>;
  creation_time: Scalars['DateTime']['output'];
  group_uuid: Scalars['String']['output'];
  is_editable: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_by_type?: Maybe<Scalars['String']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['DateTime']['output'];
  list?: Maybe<WaiverList>;
  name: Scalars['String']['output'];
  record_status: Scalars['String']['output'];
  required_for_types: Array<WaiverTemplateType>;
  short_name: Scalars['String']['output'];
  status: WaiverQuestionStatus;
  type_id: WaiverQuestionType;
  uuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  waiver_category_uuid: Scalars['String']['output'];
  waiver_list_uuid?: Maybe<Scalars['String']['output']>;
};

export type WaiverQuestionInput = {
  label: Scalars['String']['input'];
  short_name: Scalars['String']['input'];
  type_id: WaiverQuestionType;
  waiver_category_uuid: Scalars['String']['input'];
  waiver_list_uuid?: InputMaybe<Scalars['String']['input']>;
};

/** A paginated list of WaiverQuestion items. */
export type WaiverQuestionPaginator = {
  __typename?: 'WaiverQuestionPaginator';
  /** A list of WaiverQuestion items. */
  data: Array<WaiverQuestion>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type WaiverQuestionSearchInputGenerated = {
  groupUuid?: InputMaybe<Scalars['String']['input']>;
  groupUuidOperator?: InputMaybe<Scalars['String']['input']>;
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableOperator?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  labelOperator?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusOperator?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Array<WaiverQuestionType>>;
  typeIdOperator?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuidOperator?: InputMaybe<Scalars['String']['input']>;
  waiverCategoryUuid?: InputMaybe<Array<Scalars['String']['input']>>;
  waiverCategoryUuidOperator?: InputMaybe<Scalars['String']['input']>;
};

export enum WaiverQuestionStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export enum WaiverQuestionType {
  Boolean = 'Boolean',
  Date = 'Date',
  DateTime = 'DateTime',
  Email = 'Email',
  MultiSelect = 'MultiSelect',
  Numeric = 'Numeric',
  Phone = 'Phone',
  Select = 'Select',
  TextArea = 'TextArea',
  TextInput = 'TextInput'
}

export type WaiverTemplate = {
  __typename?: 'WaiverTemplate';
  category: WaiverCategory;
  created_by?: Maybe<Scalars['Int']['output']>;
  created_by_name?: Maybe<Scalars['String']['output']>;
  created_by_type?: Maybe<Scalars['String']['output']>;
  creation_time: Scalars['DateTime']['output'];
  group_uuid: Scalars['String']['output'];
  items: Array<WaiverTemplateItem>;
  label: Scalars['String']['output'];
  last_interaction_by_name?: Maybe<Scalars['String']['output']>;
  last_interaction_by_type?: Maybe<Scalars['String']['output']>;
  last_interaction_time: Scalars['DateTime']['output'];
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_by_type?: Maybe<Scalars['String']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['DateTime']['output'];
  period: WaiverTemplatePeriod;
  record_status: Scalars['String']['output'];
  status: WaiverTemplateStatus;
  type: WaiverTemplateType;
  uuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  waiver_category_uuid: Scalars['String']['output'];
};

export type WaiverTemplateColumnPayloadInput = {
  span: Scalars['Int']['input'];
};

export enum WaiverTemplateHtmlKind {
  Divider = 'Divider',
  Header = 'Header',
  Paragraph = 'Paragraph',
  Spacer = 'Spacer'
}

export type WaiverTemplateHtmlPayloadInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  kind: WaiverTemplateHtmlKind;
};

export type WaiverTemplateInput = {
  items: Array<WaiverTemplateItemInput>;
  label: Scalars['String']['input'];
  period: WaiverTemplatePeriod;
  type?: InputMaybe<WaiverTemplateType>;
  waiver_category_uuid: Scalars['String']['input'];
};

export type WaiverTemplateItem = {
  __typename?: 'WaiverTemplateItem';
  children: Array<WaiverTemplateItem>;
  content?: Maybe<WaiverContent>;
  creation_time: Scalars['DateTime']['output'];
  fields: Array<WaiverTemplateItemField>;
  last_update_time: Scalars['DateTime']['output'];
  parent_item_uuid?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  question?: Maybe<WaiverQuestion>;
  question_required?: Maybe<Scalars['Boolean']['output']>;
  type: WaiverTemplateItemType;
  uuid: Scalars['String']['output'];
  waiver_content_uuid?: Maybe<Scalars['String']['output']>;
  waiver_question_uuid?: Maybe<Scalars['String']['output']>;
  waiver_template_uuid: Scalars['String']['output'];
};

export type WaiverTemplateItemField = {
  __typename?: 'WaiverTemplateItemField';
  creation_time: Scalars['DateTime']['output'];
  last_update_time: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  type: WaiverTemplateItemFieldType;
  uuid: Scalars['String']['output'];
  waiver_template_item_uuid: Scalars['String']['output'];
};

export enum WaiverTemplateItemFieldType {
  Date = 'Date',
  Number = 'Number',
  Text = 'Text'
}

export type WaiverTemplateItemInput = {
  item_reference: Scalars['String']['input'];
  parent_item_reference?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<WaiverTemplateItemPayloadInput>;
  position: Scalars['Int']['input'];
  question_required?: InputMaybe<Scalars['Boolean']['input']>;
  type: WaiverTemplateItemType;
  waiver_content_uuid?: InputMaybe<Scalars['String']['input']>;
  waiver_question_uuid?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A type-specific payload for a template item. Exactly one branch may be
 * provided and it should match the item `type` (html, row, or column). This
 * emulates a `@oneOf` input union, which Lighthouse does not natively support;
 * the single-branch constraint is enforced during validation.
 */
export type WaiverTemplateItemPayloadInput = {
  column?: InputMaybe<WaiverTemplateColumnPayloadInput>;
  html?: InputMaybe<WaiverTemplateHtmlPayloadInput>;
  row?: InputMaybe<WaiverTemplateRowPayloadInput>;
};

export enum WaiverTemplateItemType {
  Column = 'Column',
  Content = 'Content',
  Html = 'Html',
  Question = 'Question',
  Row = 'Row'
}

/** A paginated list of WaiverTemplate items. */
export type WaiverTemplatePaginator = {
  __typename?: 'WaiverTemplatePaginator';
  /** A list of WaiverTemplate items. */
  data: Array<WaiverTemplate>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum WaiverTemplatePeriod {
  AcademicYear = 'AcademicYear',
  Lifetime = 'Lifetime',
  SingleEvent = 'SingleEvent'
}

export type WaiverTemplateRowPayloadInput = {
  columns: Scalars['Int']['input'];
};

export type WaiverTemplateSearchInputGenerated = {
  groupUuid?: InputMaybe<Scalars['String']['input']>;
  groupUuidOperator?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  labelOperator?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Array<WaiverTemplatePeriod>>;
  periodOperator?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<WaiverTemplateStatus>>;
  statusOperator?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuidOperator?: InputMaybe<Scalars['String']['input']>;
  waiverCategoryUuid?: InputMaybe<Array<Scalars['String']['input']>>;
  waiverCategoryUuidOperator?: InputMaybe<Scalars['String']['input']>;
};

export enum WaiverTemplateStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

export enum WaiverTemplateType {
  ParentFormsForMinors = 'ParentFormsForMinors',
  RegularForm = 'RegularForm'
}

export type ZdTicket = {
  __typename?: 'ZDTicket';
  allow_attachments?: Maybe<Scalars['Boolean']['output']>;
  allow_channelback?: Maybe<Scalars['Boolean']['output']>;
  assignee_id?: Maybe<Scalars['Float']['output']>;
  brand_id?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  due_at?: Maybe<Scalars['String']['output']>;
  from_messaging_channel?: Maybe<Scalars['Boolean']['output']>;
  group_id?: Maybe<Scalars['Float']['output']>;
  has_incidents?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  is_public?: Maybe<Scalars['Boolean']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  raw_subject?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  requester_id?: Maybe<Scalars['Float']['output']>;
  status: ZdTicketPriority;
  subject?: Maybe<Scalars['String']['output']>;
  submitter_id?: Maybe<Scalars['Float']['output']>;
  ticket_form_id?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<ZdTicketType>;
  updated_at?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ZdTicketComment = {
  __typename?: 'ZDTicketComment';
  audit_id?: Maybe<Scalars['Float']['output']>;
  author_id: Scalars['Float']['output'];
  body?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  html_body?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  plain_body?: Maybe<Scalars['String']['output']>;
  public: Scalars['Boolean']['output'];
};

export type ZdTicketComments = {
  __typename?: 'ZDTicketComments';
  comments: Array<ZdTicketComment>;
  paginatorInfo: PaginatorInfo;
  users: Array<ZdUser>;
};

/** A paginated list of ZDTicket items. */
export type ZdTicketPaginator = {
  __typename?: 'ZDTicketPaginator';
  /** A list of ZDTicket items. */
  data: Array<ZdTicket>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum ZdTicketPriority {
  Closed = 'closed',
  Hold = 'hold',
  New = 'new',
  Open = 'open',
  Pending = 'pending',
  Solved = 'solved'
}

export enum ZdTicketType {
  Incident = 'incident',
  Problem = 'problem',
  Question = 'question',
  Task = 'task'
}

export type ZdTicketUser = {
  __typename?: 'ZDTicketUser';
  ticket?: Maybe<ZdTicket>;
  users: Array<ZdUser>;
};

export type ZdTicketsInput = {
  portal_contact_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ZdUser = {
  __typename?: 'ZDUser';
  created_at: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type PortalContactSelectFragmentFragment = { __typename?: 'PortalContact', id: number, first_name: string, last_name: string };

export type PortalContactsSelectQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  search: PortalContactsInput;
}>;


export type PortalContactsSelectQuery = { __typename?: 'Query', portalContacts: { __typename?: 'PortalContactPaginator', data: Array<{ __typename?: 'PortalContact', id: number, first_name: string, last_name: string }> } };

export type WaiverCategoryFragmentFragment = { __typename?: 'WaiverCategory', uuid: string, partner_id: number, name: string, desc?: string | undefined, status: WaiverCategoryStatus, is_global: boolean, is_editable: boolean, total_users: number, portal_contact_ids: Array<number> };

export type WaiverCategoriesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
  showAllByAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  inputGenerated?: InputMaybe<WaiverCategorySearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
}>;


export type WaiverCategoriesQuery = { __typename?: 'Query', waiverCategories: { __typename?: 'WaiverCategoryPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'WaiverCategory', uuid: string, partner_id: number, name: string, desc?: string | undefined, status: WaiverCategoryStatus, is_global: boolean, is_editable: boolean, total_users: number, portal_contact_ids: Array<number> }> } };

export type WaiverCategoryUserFragmentFragment = { __typename?: 'PortalContact', id: number, first_name: string, last_name: string, preferred_name?: string | undefined, waiverCategories: Array<{ __typename?: 'WaiverCategory', uuid: string, name: string }> };

export type WaiverCategoryUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
  search: PortalContactsInput;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
}>;


export type WaiverCategoryUsersQuery = { __typename?: 'Query', waiverCategoryUsers: { __typename?: 'PortalContactPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'PortalContact', id: number, first_name: string, last_name: string, preferred_name?: string | undefined, waiverCategories: Array<{ __typename?: 'WaiverCategory', uuid: string, name: string }> }> } };

export type WaiverContentFragmentFragment = { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined };

export type WaiverContentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
  inputGenerated?: InputMaybe<WaiverContentSearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
  orderByCategoryName?: InputMaybe<SortOrder>;
}>;


export type WaiverContentsQuery = { __typename?: 'Query', waiverContents: { __typename?: 'WaiverContentPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined }> } };

export type WaiverFormFragmentFragment = { __typename?: 'WaiverForm', uuid: string, group_uuid: string, waiver_template_uuid: string, name: string, live_start_date: any, live_end_date: any, status: WaiverFormStatus, displayStatus: WaiverFormDisplayStatus, submissions_count: number, last_interaction_by_name?: string | undefined, last_update_time: any, template: { __typename?: 'WaiverTemplate', uuid: string, label: string, period: WaiverTemplatePeriod, category: { __typename?: 'WaiverCategory', uuid: string, name: string } } };

export type WaiverFormItemFieldFragmentFragment = { __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType };

export type WaiverFormTemplateItemNestedFragmentFragment = { __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> };

export type WaiverFormTemplateItemFragmentFragment = { __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> };

export type WaiverFormDetailFragmentFragment = { __typename?: 'WaiverForm', uuid: string, group_uuid: string, waiver_template_uuid: string, name: string, live_start_date: any, live_end_date: any, status: WaiverFormStatus, last_interaction_by_name?: string | undefined, last_interaction_time: any, template: { __typename?: 'WaiverTemplate', uuid: string, label: string, period: WaiverTemplatePeriod, status: WaiverTemplateStatus, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }> }, currentTemplate?: { __typename?: 'WaiverTemplate', uuid: string, label: string, period: WaiverTemplatePeriod, status: WaiverTemplateStatus, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }> } | undefined, fields: Array<{ __typename?: 'WaiverFormField', uuid: string, value?: string | undefined, format?: string | undefined, waiver_template_item_field_uuid: string, templateItemField: { __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType } }> };

export type WaiverFormQueryVariables = Exact<{
  groupUuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
}>;


export type WaiverFormQuery = { __typename?: 'Query', waiverForm?: { __typename?: 'WaiverForm', uuid: string, group_uuid: string, waiver_template_uuid: string, name: string, live_start_date: any, live_end_date: any, status: WaiverFormStatus, last_interaction_by_name?: string | undefined, last_interaction_time: any, template: { __typename?: 'WaiverTemplate', uuid: string, label: string, period: WaiverTemplatePeriod, status: WaiverTemplateStatus, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }> }, currentTemplate?: { __typename?: 'WaiverTemplate', uuid: string, label: string, period: WaiverTemplatePeriod, status: WaiverTemplateStatus, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }> } | undefined, fields: Array<{ __typename?: 'WaiverFormField', uuid: string, value?: string | undefined, format?: string | undefined, waiver_template_item_field_uuid: string, templateItemField: { __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType } }> } | undefined };

export type WaiverFormsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
  inputGenerated?: InputMaybe<WaiverFormSearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
  orderByTemplateLabel?: InputMaybe<SortOrder>;
  orderByCategoryName?: InputMaybe<SortOrder>;
}>;


export type WaiverFormsQuery = { __typename?: 'Query', waiverForms: { __typename?: 'WaiverFormPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'WaiverForm', uuid: string, group_uuid: string, waiver_template_uuid: string, name: string, live_start_date: any, live_end_date: any, status: WaiverFormStatus, displayStatus: WaiverFormDisplayStatus, submissions_count: number, last_interaction_by_name?: string | undefined, last_update_time: any, template: { __typename?: 'WaiverTemplate', uuid: string, label: string, period: WaiverTemplatePeriod, category: { __typename?: 'WaiverCategory', uuid: string, name: string } } }> } };

export type WaiverListOptionFragmentFragment = { __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus };

export type WaiverListFragmentFragment = { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> };

export type WaiverListsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
  inputGenerated?: InputMaybe<WaiverListSearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
}>;


export type WaiverListsQuery = { __typename?: 'Query', waiverLists: { __typename?: 'WaiverListPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> }> } };

export type WaiverQuestionFragmentFragment = { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined };

export type WaiverQuestionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
  inputGenerated?: InputMaybe<WaiverQuestionSearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
  orderByCategoryName?: InputMaybe<SortOrder>;
}>;


export type WaiverQuestionsQuery = { __typename?: 'Query', waiverQuestions: { __typename?: 'WaiverQuestionPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined }> } };

export type WaiverFormSubmissionFragmentFragment = { __typename?: 'WaiverFormSubmission', uuid: string, submitted_at: any, is_test: boolean, student_id?: string | undefined, first_name?: string | undefined, last_name?: string | undefined, email?: string | undefined, form: { __typename?: 'WaiverForm', uuid: string, group_uuid: string, name: string, template: { __typename?: 'WaiverTemplate', uuid: string, label: string, category: { __typename?: 'WaiverCategory', uuid: string, name: string } } } };

export type WaiverFormSubmissionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
  inputGenerated?: InputMaybe<WaiverFormSubmissionSearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
  orderByFirstName?: InputMaybe<SortOrder>;
  orderByLastName?: InputMaybe<SortOrder>;
  orderByFormName?: InputMaybe<SortOrder>;
  orderByTemplateLabel?: InputMaybe<SortOrder>;
  orderByCategoryName?: InputMaybe<SortOrder>;
}>;


export type WaiverFormSubmissionsQuery = { __typename?: 'Query', waiverFormSubmissions: { __typename?: 'WaiverFormSubmissionPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'WaiverFormSubmission', uuid: string, submitted_at: any, is_test: boolean, student_id?: string | undefined, first_name?: string | undefined, last_name?: string | undefined, email?: string | undefined, form: { __typename?: 'WaiverForm', uuid: string, group_uuid: string, name: string, template: { __typename?: 'WaiverTemplate', uuid: string, label: string, category: { __typename?: 'WaiverCategory', uuid: string, name: string } } } }> } };

export type WaiverTemplateItemNestedFragmentFragment = { __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined };

export type WaiverTemplateItemFragmentFragment = { __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined };

export type WaiverTemplateFragmentFragment = { __typename?: 'WaiverTemplate', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, period: WaiverTemplatePeriod, type: WaiverTemplateType, status: WaiverTemplateStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }> };

export type WaiverTemplatesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id: Scalars['Int']['input'];
  inputGenerated?: InputMaybe<WaiverTemplateSearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
  orderByCategoryName?: InputMaybe<SortOrder>;
}>;


export type WaiverTemplatesQuery = { __typename?: 'Query', waiverTemplates: { __typename?: 'WaiverTemplatePaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'WaiverTemplate', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, period: WaiverTemplatePeriod, type: WaiverTemplateType, status: WaiverTemplateStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }> }> } };

export type WaiverTemplateQueryVariables = Exact<{
  groupUuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
}>;


export type WaiverTemplateQuery = { __typename?: 'Query', waiverTemplate?: { __typename?: 'WaiverTemplate', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, period: WaiverTemplatePeriod, type: WaiverTemplateType, status: WaiverTemplateStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }> } | undefined };

export type MessageResponseFragmentFragment = { __typename?: 'MessageResponse', message: string, type: MessageResponseType };

export type PaginationFragmentFragment = { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean };

export type ColorRgbFragmentFragment = { __typename?: 'ColorRGB', r: number, g: number, b: number };

export type PartnerColorsFragmentFragment = { __typename?: 'PartnerColors', logoOneColor?: boolean | undefined, bg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, text: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuFocus: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedBg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHover: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHoverText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, logoColor: { __typename?: 'ColorRGB', r: number, g: number, b: number } };

export type PartnerSessionFragmentFragment = { __typename?: 'Partner', id: number, uuid: string, name: string, school_id: number, liability_waiver?: boolean | undefined, sessionStatus: PortalContactStatus, colors: { __typename?: 'PartnerColors', logoOneColor?: boolean | undefined, bg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, text: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuFocus: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedBg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHover: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHoverText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, logoColor: { __typename?: 'ColorRGB', r: number, g: number, b: number } }, sessionRights?: Array<{ __typename?: 'PartnerRight', id: number, code: string }> | undefined, refCodes: Array<{ __typename?: 'RefCode', id: number, code: string }>, school: { __typename?: 'School', id: number, school_name: string, address1: string, address2?: string | undefined, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | undefined, website_url?: string | undefined, erp_code?: string | undefined, renters_contract_id?: string | undefined, tuition_contract_id?: string | undefined, hasRentersCoverageConfirmationPro: boolean, hasRentersCoverageConfirmationLite: boolean, primaryRefCode?: { __typename?: 'RefCode', id: number, lastTerm?: { __typename?: 'RefCodeTerm', id: number, uuid?: string | undefined, ref_code_id: number, term_name: string, term_start?: any | undefined, term_end?: any | undefined, offer_open_date?: any | undefined } | undefined, currentRentersImplementation?: { __typename?: 'RentersImplementation', id: number, effective_date?: string | undefined, start_date?: string | undefined, default_property_coverage?: number | undefined, default_liability_coverage?: number | undefined } | undefined, currentTuitionImplementation?: { __typename?: 'TuitionImplementation', id: number, season: string, term: string, effective_date?: string | undefined, payment_gateway?: string | undefined, ref_code_id: number } | undefined } | undefined } };

export type PartnerPortalContactSessionFragmentFragment = { __typename?: 'PartnerPortalContact', id: number, partner_id: number, contact_status: PortalContactStatus, partner: { __typename?: 'Partner', id: number, uuid: string, name: string, school_id: number, liability_waiver?: boolean | undefined, sessionStatus: PortalContactStatus, colors: { __typename?: 'PartnerColors', logoOneColor?: boolean | undefined, bg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, text: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuFocus: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedBg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHover: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHoverText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, logoColor: { __typename?: 'ColorRGB', r: number, g: number, b: number } }, sessionRights?: Array<{ __typename?: 'PartnerRight', id: number, code: string }> | undefined, refCodes: Array<{ __typename?: 'RefCode', id: number, code: string }>, school: { __typename?: 'School', id: number, school_name: string, address1: string, address2?: string | undefined, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | undefined, website_url?: string | undefined, erp_code?: string | undefined, renters_contract_id?: string | undefined, tuition_contract_id?: string | undefined, hasRentersCoverageConfirmationPro: boolean, hasRentersCoverageConfirmationLite: boolean, primaryRefCode?: { __typename?: 'RefCode', id: number, lastTerm?: { __typename?: 'RefCodeTerm', id: number, uuid?: string | undefined, ref_code_id: number, term_name: string, term_start?: any | undefined, term_end?: any | undefined, offer_open_date?: any | undefined } | undefined, currentRentersImplementation?: { __typename?: 'RentersImplementation', id: number, effective_date?: string | undefined, start_date?: string | undefined, default_property_coverage?: number | undefined, default_liability_coverage?: number | undefined } | undefined, currentTuitionImplementation?: { __typename?: 'TuitionImplementation', id: number, season: string, term: string, effective_date?: string | undefined, payment_gateway?: string | undefined, ref_code_id: number } | undefined } | undefined } } };

export type PortalContactSessionFragmentFragment = { __typename?: 'PortalContact', id: number, partner_id_default?: number | undefined, first_name: string, last_name: string, preferred_name?: string | undefined, email: string, pronouns?: string | undefined, sms_phone?: string | undefined, requiresMfa?: boolean | undefined, portal_contact_status: PortalContactStatus, locked?: boolean | undefined, uuid: string, terms_and_conditions_acknowledgment_dt?: string | undefined, sessionImpersonation?: boolean | undefined, partnerPortalContactsActive: Array<{ __typename?: 'PartnerPortalContact', id: number, partner_id: number, contact_status: PortalContactStatus, partner: { __typename?: 'Partner', id: number, uuid: string, name: string, school_id: number, liability_waiver?: boolean | undefined, sessionStatus: PortalContactStatus, colors: { __typename?: 'PartnerColors', logoOneColor?: boolean | undefined, bg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, text: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuFocus: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedBg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHover: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHoverText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, logoColor: { __typename?: 'ColorRGB', r: number, g: number, b: number } }, sessionRights?: Array<{ __typename?: 'PartnerRight', id: number, code: string }> | undefined, refCodes: Array<{ __typename?: 'RefCode', id: number, code: string }>, school: { __typename?: 'School', id: number, school_name: string, address1: string, address2?: string | undefined, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | undefined, website_url?: string | undefined, erp_code?: string | undefined, renters_contract_id?: string | undefined, tuition_contract_id?: string | undefined, hasRentersCoverageConfirmationPro: boolean, hasRentersCoverageConfirmationLite: boolean, primaryRefCode?: { __typename?: 'RefCode', id: number, lastTerm?: { __typename?: 'RefCodeTerm', id: number, uuid?: string | undefined, ref_code_id: number, term_name: string, term_start?: any | undefined, term_end?: any | undefined, offer_open_date?: any | undefined } | undefined, currentRentersImplementation?: { __typename?: 'RentersImplementation', id: number, effective_date?: string | undefined, start_date?: string | undefined, default_property_coverage?: number | undefined, default_liability_coverage?: number | undefined } | undefined, currentTuitionImplementation?: { __typename?: 'TuitionImplementation', id: number, season: string, term: string, effective_date?: string | undefined, payment_gateway?: string | undefined, ref_code_id: number } | undefined } | undefined } } }> };

export type SchoolFragmentFragment = { __typename?: 'School', id: number, school_name: string, address1: string, address2?: string | undefined, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | undefined, website_url?: string | undefined, erp_code?: string | undefined, renters_contract_id?: string | undefined, tuition_contract_id?: string | undefined, hasRentersCoverageConfirmationPro: boolean, hasRentersCoverageConfirmationLite: boolean, primaryRefCode?: { __typename?: 'RefCode', id: number, lastTerm?: { __typename?: 'RefCodeTerm', id: number, uuid?: string | undefined, ref_code_id: number, term_name: string, term_start?: any | undefined, term_end?: any | undefined, offer_open_date?: any | undefined } | undefined, currentRentersImplementation?: { __typename?: 'RentersImplementation', id: number, effective_date?: string | undefined, start_date?: string | undefined, default_property_coverage?: number | undefined, default_liability_coverage?: number | undefined } | undefined, currentTuitionImplementation?: { __typename?: 'TuitionImplementation', id: number, season: string, term: string, effective_date?: string | undefined, payment_gateway?: string | undefined, ref_code_id: number } | undefined } | undefined };

export type RefCodeTermFragmentFragment = { __typename?: 'RefCodeTerm', id: number, uuid?: string | undefined, ref_code_id: number, term_name: string, term_start?: any | undefined, term_end?: any | undefined, offer_open_date?: any | undefined };

export type TuitionImplementationFragmentFragment = { __typename?: 'TuitionImplementation', id: number, season: string, term: string, effective_date?: string | undefined, payment_gateway?: string | undefined, ref_code_id: number };

export type AgentFragmentFragment = { __typename?: 'Agent', id: number, first_name: string, last_name: string, email: string, full_name: string };

export type SalesRepresentativeQueryVariables = Exact<{
  school_id: Scalars['Int']['input'];
}>;


export type SalesRepresentativeQuery = { __typename?: 'Query', salesRepresentative?: { __typename?: 'Agent', id: number, first_name: string, last_name: string, email: string, full_name: string } | undefined };

export type RentersAccountManagerQueryVariables = Exact<{
  partner_id: Scalars['Int']['input'];
}>;


export type RentersAccountManagerQuery = { __typename?: 'Query', rentersAccountManager?: { __typename?: 'Agent', id: number, first_name: string, last_name: string, email: string, full_name: string } | undefined };

export type TuitionAccountManagerQueryVariables = Exact<{
  partner_id: Scalars['Int']['input'];
}>;


export type TuitionAccountManagerQuery = { __typename?: 'Query', tuitionAccountManager?: { __typename?: 'Agent', id: number, first_name: string, last_name: string, email: string, full_name: string } | undefined };

export type PartnerPortalContactFragmentFragment = { __typename?: 'PartnerPortalContact', partner_id: number, portal_contact_id: number, contact_status: PortalContactStatus };

export type PortalContactFragmentFragment = { __typename?: 'PortalContact', id: number, partner_id_default?: number | undefined, first_name: string, last_name: string, preferred_name?: string | undefined, email: string, pronouns?: string | undefined, sms_phone?: string | undefined, requiresMfa?: boolean | undefined, portal_contact_status: PortalContactStatus, locked?: boolean | undefined, uuid: string };

export type PortalContactTableFragmentFragment = { __typename?: 'PortalContact', id: number, partner_id_default?: number | undefined, first_name: string, last_name: string, preferred_name?: string | undefined, email: string, pronouns?: string | undefined, sms_phone?: string | undefined, requiresMfa?: boolean | undefined, portal_contact_status: PortalContactStatus, locked?: boolean | undefined, uuid: string, partnerPortalContact: { __typename?: 'PartnerPortalContact', partner_id: number, portal_contact_id: number, contact_status: PortalContactStatus } };

export type PortalContactCreateMutationVariables = Exact<{
  partner_id: Scalars['Int']['input'];
  input: PortalContactCreateInput;
}>;


export type PortalContactCreateMutation = { __typename?: 'Mutation', portalContactCreate?: { __typename?: 'PortalContactMessageType', message: string, type: MessageResponseType, data: { __typename?: 'PortalContact', id: number, partner_id_default?: number | undefined, first_name: string, last_name: string, preferred_name?: string | undefined, email: string, pronouns?: string | undefined, sms_phone?: string | undefined, requiresMfa?: boolean | undefined, portal_contact_status: PortalContactStatus, locked?: boolean | undefined, uuid: string } } | undefined };

export type PortalContactUpdateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: PortalContactUpdateInput;
}>;


export type PortalContactUpdateMutation = { __typename?: 'Mutation', portalContactUpdate?: { __typename?: 'PortalContact', id: number, partner_id_default?: number | undefined, first_name: string, last_name: string, preferred_name?: string | undefined, email: string, pronouns?: string | undefined, sms_phone?: string | undefined, requiresMfa?: boolean | undefined, portal_contact_status: PortalContactStatus, locked?: boolean | undefined, uuid: string } | undefined };

export type PortalContactSendWelcomeEmailMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PortalContactSendWelcomeEmailMutation = { __typename?: 'Mutation', portalContactSendWelcomeEmail?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type PortalContactRequestResetPassMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PortalContactRequestResetPassMutation = { __typename?: 'Mutation', portalContactRequestResetPass?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type PortalContactsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
  search: PortalContactsInput;
  partner_id: Scalars['Int']['input'];
}>;


export type PortalContactsQuery = { __typename?: 'Query', portalContacts: { __typename?: 'PortalContactPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'PortalContact', id: number, partner_id_default?: number | undefined, first_name: string, last_name: string, preferred_name?: string | undefined, email: string, pronouns?: string | undefined, sms_phone?: string | undefined, requiresMfa?: boolean | undefined, portal_contact_status: PortalContactStatus, locked?: boolean | undefined, uuid: string, partnerPortalContact: { __typename?: 'PartnerPortalContact', partner_id: number, portal_contact_id: number, contact_status: PortalContactStatus } }> } };

export type PortalContactQueryVariables = Exact<{
  search: PortalContactInput;
  partner_id: Scalars['Int']['input'];
}>;


export type PortalContactQuery = { __typename?: 'Query', portalContact?: { __typename?: 'PortalContact', id: number, partner_id_default?: number | undefined, first_name: string, last_name: string, preferred_name?: string | undefined, email: string, pronouns?: string | undefined, sms_phone?: string | undefined, requiresMfa?: boolean | undefined, portal_contact_status: PortalContactStatus, locked?: boolean | undefined, uuid: string, partnerPortalContact: { __typename?: 'PartnerPortalContact', partner_id: number, portal_contact_id: number, contact_status: PortalContactStatus } } | undefined };

export type PortalContactStatusUpdateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  partner_id: Scalars['Int']['input'];
  contact_status: PortalContactStatus;
}>;


export type PortalContactStatusUpdateMutation = { __typename?: 'Mutation', portalContactStatusUpdate?: { __typename?: 'PortalContactMessageType', message: string, type: MessageResponseType, data: { __typename?: 'PortalContact', id: number, partner_id_default?: number | undefined, first_name: string, last_name: string, preferred_name?: string | undefined, email: string, pronouns?: string | undefined, sms_phone?: string | undefined, requiresMfa?: boolean | undefined, portal_contact_status: PortalContactStatus, locked?: boolean | undefined, uuid: string, partnerPortalContact: { __typename?: 'PartnerPortalContact', partner_id: number, portal_contact_id: number, contact_status: PortalContactStatus } } } | undefined };

export type PortalContactUnlockMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PortalContactUnlockMutation = { __typename?: 'Mutation', portalContactUnlock: { __typename?: 'PortalContact', id: number, partner_id_default?: number | undefined, first_name: string, last_name: string, preferred_name?: string | undefined, email: string, pronouns?: string | undefined, sms_phone?: string | undefined, requiresMfa?: boolean | undefined, portal_contact_status: PortalContactStatus, locked?: boolean | undefined, uuid: string } };

export type PartnerRoleFragmentFragment = { __typename?: 'PartnerRole', id: number, code: string, name: string, description: string };

export type PartnerContactRolesUpdateMutationVariables = Exact<{
  contactId: Scalars['Int']['input'];
  partnerId: Scalars['Int']['input'];
  create?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  delete?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type PartnerContactRolesUpdateMutation = { __typename?: 'Mutation', partnerContactRolesUpdate?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type PartnerRolesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
  search: PartnerRolesSearchInput;
}>;


export type PartnerRolesQuery = { __typename?: 'Query', partnerRoles: { __typename?: 'PartnerRolePaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'PartnerRole', id: number, code: string, name: string, description: string }> } };

export type PartnerContactRolesQueryVariables = Exact<{
  partner_id: Scalars['Int']['input'];
  contact_id: Scalars['Int']['input'];
}>;


export type PartnerContactRolesQuery = { __typename?: 'Query', partnerContactRoles?: Array<{ __typename?: 'PartnerRole', id: number, code: string, name: string, description: string }> | undefined };

export type PortalContactAcceptTermsConditionsMutationVariables = Exact<{ [key: string]: never; }>;


export type PortalContactAcceptTermsConditionsMutation = { __typename?: 'Mutation', portalContactAcceptTermsConditions?: { __typename?: 'PortalContact', id: number, partner_id_default?: number | undefined, first_name: string, last_name: string, preferred_name?: string | undefined, email: string, pronouns?: string | undefined, sms_phone?: string | undefined, requiresMfa?: boolean | undefined, portal_contact_status: PortalContactStatus, locked?: boolean | undefined, uuid: string, terms_and_conditions_acknowledgment_dt?: string | undefined, sessionImpersonation?: boolean | undefined, partnerPortalContactsActive: Array<{ __typename?: 'PartnerPortalContact', id: number, partner_id: number, contact_status: PortalContactStatus, partner: { __typename?: 'Partner', id: number, uuid: string, name: string, school_id: number, liability_waiver?: boolean | undefined, sessionStatus: PortalContactStatus, colors: { __typename?: 'PartnerColors', logoOneColor?: boolean | undefined, bg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, text: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuFocus: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedBg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHover: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHoverText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, logoColor: { __typename?: 'ColorRGB', r: number, g: number, b: number } }, sessionRights?: Array<{ __typename?: 'PartnerRight', id: number, code: string }> | undefined, refCodes: Array<{ __typename?: 'RefCode', id: number, code: string }>, school: { __typename?: 'School', id: number, school_name: string, address1: string, address2?: string | undefined, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | undefined, website_url?: string | undefined, erp_code?: string | undefined, renters_contract_id?: string | undefined, tuition_contract_id?: string | undefined, hasRentersCoverageConfirmationPro: boolean, hasRentersCoverageConfirmationLite: boolean, primaryRefCode?: { __typename?: 'RefCode', id: number, lastTerm?: { __typename?: 'RefCodeTerm', id: number, uuid?: string | undefined, ref_code_id: number, term_name: string, term_start?: any | undefined, term_end?: any | undefined, offer_open_date?: any | undefined } | undefined, currentRentersImplementation?: { __typename?: 'RentersImplementation', id: number, effective_date?: string | undefined, start_date?: string | undefined, default_property_coverage?: number | undefined, default_liability_coverage?: number | undefined } | undefined, currentTuitionImplementation?: { __typename?: 'TuitionImplementation', id: number, season: string, term: string, effective_date?: string | undefined, payment_gateway?: string | undefined, ref_code_id: number } | undefined } | undefined } } }> } | undefined };

export type PortalContactLoggedQueryVariables = Exact<{ [key: string]: never; }>;


export type PortalContactLoggedQuery = { __typename?: 'Query', portalContactLogged?: { __typename?: 'PortalContact', id: number, partner_id_default?: number | undefined, first_name: string, last_name: string, preferred_name?: string | undefined, email: string, pronouns?: string | undefined, sms_phone?: string | undefined, requiresMfa?: boolean | undefined, portal_contact_status: PortalContactStatus, locked?: boolean | undefined, uuid: string, terms_and_conditions_acknowledgment_dt?: string | undefined, sessionImpersonation?: boolean | undefined, partnerPortalContactsActive: Array<{ __typename?: 'PartnerPortalContact', id: number, partner_id: number, contact_status: PortalContactStatus, partner: { __typename?: 'Partner', id: number, uuid: string, name: string, school_id: number, liability_waiver?: boolean | undefined, sessionStatus: PortalContactStatus, colors: { __typename?: 'PartnerColors', logoOneColor?: boolean | undefined, bg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, text: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuFocus: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedBg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHover: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHoverText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, logoColor: { __typename?: 'ColorRGB', r: number, g: number, b: number } }, sessionRights?: Array<{ __typename?: 'PartnerRight', id: number, code: string }> | undefined, refCodes: Array<{ __typename?: 'RefCode', id: number, code: string }>, school: { __typename?: 'School', id: number, school_name: string, address1: string, address2?: string | undefined, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | undefined, website_url?: string | undefined, erp_code?: string | undefined, renters_contract_id?: string | undefined, tuition_contract_id?: string | undefined, hasRentersCoverageConfirmationPro: boolean, hasRentersCoverageConfirmationLite: boolean, primaryRefCode?: { __typename?: 'RefCode', id: number, lastTerm?: { __typename?: 'RefCodeTerm', id: number, uuid?: string | undefined, ref_code_id: number, term_name: string, term_start?: any | undefined, term_end?: any | undefined, offer_open_date?: any | undefined } | undefined, currentRentersImplementation?: { __typename?: 'RentersImplementation', id: number, effective_date?: string | undefined, start_date?: string | undefined, default_property_coverage?: number | undefined, default_liability_coverage?: number | undefined } | undefined, currentTuitionImplementation?: { __typename?: 'TuitionImplementation', id: number, season: string, term: string, effective_date?: string | undefined, payment_gateway?: string | undefined, ref_code_id: number } | undefined } | undefined } } }> } | undefined };

export type PortalContactSessionPasswordUpdateMutationVariables = Exact<{
  input: PortalContactSessionPasswordUpdateInput;
}>;


export type PortalContactSessionPasswordUpdateMutation = { __typename?: 'Mutation', portalContactSessionPasswordUpdate?: { __typename?: 'PortalContact', id: number, partner_id_default?: number | undefined, first_name: string, last_name: string, preferred_name?: string | undefined, email: string, pronouns?: string | undefined, sms_phone?: string | undefined, requiresMfa?: boolean | undefined, portal_contact_status: PortalContactStatus, locked?: boolean | undefined, uuid: string, terms_and_conditions_acknowledgment_dt?: string | undefined, sessionImpersonation?: boolean | undefined, partnerPortalContactsActive: Array<{ __typename?: 'PartnerPortalContact', id: number, partner_id: number, contact_status: PortalContactStatus, partner: { __typename?: 'Partner', id: number, uuid: string, name: string, school_id: number, liability_waiver?: boolean | undefined, sessionStatus: PortalContactStatus, colors: { __typename?: 'PartnerColors', logoOneColor?: boolean | undefined, bg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, text: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuFocus: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedBg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHover: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHoverText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, logoColor: { __typename?: 'ColorRGB', r: number, g: number, b: number } }, sessionRights?: Array<{ __typename?: 'PartnerRight', id: number, code: string }> | undefined, refCodes: Array<{ __typename?: 'RefCode', id: number, code: string }>, school: { __typename?: 'School', id: number, school_name: string, address1: string, address2?: string | undefined, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | undefined, website_url?: string | undefined, erp_code?: string | undefined, renters_contract_id?: string | undefined, tuition_contract_id?: string | undefined, hasRentersCoverageConfirmationPro: boolean, hasRentersCoverageConfirmationLite: boolean, primaryRefCode?: { __typename?: 'RefCode', id: number, lastTerm?: { __typename?: 'RefCodeTerm', id: number, uuid?: string | undefined, ref_code_id: number, term_name: string, term_start?: any | undefined, term_end?: any | undefined, offer_open_date?: any | undefined } | undefined, currentRentersImplementation?: { __typename?: 'RentersImplementation', id: number, effective_date?: string | undefined, start_date?: string | undefined, default_property_coverage?: number | undefined, default_liability_coverage?: number | undefined } | undefined, currentTuitionImplementation?: { __typename?: 'TuitionImplementation', id: number, season: string, term: string, effective_date?: string | undefined, payment_gateway?: string | undefined, ref_code_id: number } | undefined } | undefined } } }> } | undefined };

export type PortalContactSessionEmailPhoneUpdateMutationVariables = Exact<{
  input: PortalContactSessionEmailPhoneUpdateInput;
}>;


export type PortalContactSessionEmailPhoneUpdateMutation = { __typename?: 'Mutation', portalContactSessionEmailPhoneUpdate?: { __typename?: 'PortalContact', id: number, partner_id_default?: number | undefined, first_name: string, last_name: string, preferred_name?: string | undefined, email: string, pronouns?: string | undefined, sms_phone?: string | undefined, requiresMfa?: boolean | undefined, portal_contact_status: PortalContactStatus, locked?: boolean | undefined, uuid: string, terms_and_conditions_acknowledgment_dt?: string | undefined, sessionImpersonation?: boolean | undefined, partnerPortalContactsActive: Array<{ __typename?: 'PartnerPortalContact', id: number, partner_id: number, contact_status: PortalContactStatus, partner: { __typename?: 'Partner', id: number, uuid: string, name: string, school_id: number, liability_waiver?: boolean | undefined, sessionStatus: PortalContactStatus, colors: { __typename?: 'PartnerColors', logoOneColor?: boolean | undefined, bg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, text: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuFocus: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedBg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHover: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHoverText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, logoColor: { __typename?: 'ColorRGB', r: number, g: number, b: number } }, sessionRights?: Array<{ __typename?: 'PartnerRight', id: number, code: string }> | undefined, refCodes: Array<{ __typename?: 'RefCode', id: number, code: string }>, school: { __typename?: 'School', id: number, school_name: string, address1: string, address2?: string | undefined, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | undefined, website_url?: string | undefined, erp_code?: string | undefined, renters_contract_id?: string | undefined, tuition_contract_id?: string | undefined, hasRentersCoverageConfirmationPro: boolean, hasRentersCoverageConfirmationLite: boolean, primaryRefCode?: { __typename?: 'RefCode', id: number, lastTerm?: { __typename?: 'RefCodeTerm', id: number, uuid?: string | undefined, ref_code_id: number, term_name: string, term_start?: any | undefined, term_end?: any | undefined, offer_open_date?: any | undefined } | undefined, currentRentersImplementation?: { __typename?: 'RentersImplementation', id: number, effective_date?: string | undefined, start_date?: string | undefined, default_property_coverage?: number | undefined, default_liability_coverage?: number | undefined } | undefined, currentTuitionImplementation?: { __typename?: 'TuitionImplementation', id: number, season: string, term: string, effective_date?: string | undefined, payment_gateway?: string | undefined, ref_code_id: number } | undefined } | undefined } } }> } | undefined };

export type PortalContactSessionUpdateMutationVariables = Exact<{
  input: PortalContactSessionUpdateInput;
}>;


export type PortalContactSessionUpdateMutation = { __typename?: 'Mutation', portalContactSessionUpdate?: { __typename?: 'PortalContact', id: number, partner_id_default?: number | undefined, first_name: string, last_name: string, preferred_name?: string | undefined, email: string, pronouns?: string | undefined, sms_phone?: string | undefined, requiresMfa?: boolean | undefined, portal_contact_status: PortalContactStatus, locked?: boolean | undefined, uuid: string, terms_and_conditions_acknowledgment_dt?: string | undefined, sessionImpersonation?: boolean | undefined, partnerPortalContactsActive: Array<{ __typename?: 'PartnerPortalContact', id: number, partner_id: number, contact_status: PortalContactStatus, partner: { __typename?: 'Partner', id: number, uuid: string, name: string, school_id: number, liability_waiver?: boolean | undefined, sessionStatus: PortalContactStatus, colors: { __typename?: 'PartnerColors', logoOneColor?: boolean | undefined, bg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, text: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuFocus: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedBg: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuSelectedText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHover: { __typename?: 'ColorRGB', r: number, g: number, b: number }, menuHoverText: { __typename?: 'ColorRGB', r: number, g: number, b: number }, logoColor: { __typename?: 'ColorRGB', r: number, g: number, b: number } }, sessionRights?: Array<{ __typename?: 'PartnerRight', id: number, code: string }> | undefined, refCodes: Array<{ __typename?: 'RefCode', id: number, code: string }>, school: { __typename?: 'School', id: number, school_name: string, address1: string, address2?: string | undefined, address_city: string, address_state: string, address_zip: string, address_country: string, logo_url?: string | undefined, website_url?: string | undefined, erp_code?: string | undefined, renters_contract_id?: string | undefined, tuition_contract_id?: string | undefined, hasRentersCoverageConfirmationPro: boolean, hasRentersCoverageConfirmationLite: boolean, primaryRefCode?: { __typename?: 'RefCode', id: number, lastTerm?: { __typename?: 'RefCodeTerm', id: number, uuid?: string | undefined, ref_code_id: number, term_name: string, term_start?: any | undefined, term_end?: any | undefined, offer_open_date?: any | undefined } | undefined, currentRentersImplementation?: { __typename?: 'RentersImplementation', id: number, effective_date?: string | undefined, start_date?: string | undefined, default_property_coverage?: number | undefined, default_liability_coverage?: number | undefined } | undefined, currentTuitionImplementation?: { __typename?: 'TuitionImplementation', id: number, season: string, term: string, effective_date?: string | undefined, payment_gateway?: string | undefined, ref_code_id: number } | undefined } | undefined } } }> } | undefined };

export type RefundPolicyFragmentFragment = { __typename?: 'RefundPolicy', id: number, uuid: string, tuition_implementation_id?: number | undefined, renters_implementation_id?: number | undefined, refund_policy_content: string, refund_policy_status: string, creation_time?: any | undefined, last_update_time?: any | undefined, last_update_by?: number | undefined, last_update_by_type?: string | undefined, created_by?: number | undefined, created_by_type?: string | undefined, last_update_reason?: string | undefined, record_status?: string | undefined };

export type RefundPoliciesQueryVariables = Exact<{
  input: RefundPoliciesInput;
}>;


export type RefundPoliciesQuery = { __typename?: 'Query', refundPolicies?: Array<{ __typename?: 'RefundPolicy', id: number, uuid: string, tuition_implementation_id?: number | undefined, renters_implementation_id?: number | undefined, refund_policy_content: string, refund_policy_status: string, creation_time?: any | undefined, last_update_time?: any | undefined, last_update_by?: number | undefined, last_update_by_type?: string | undefined, created_by?: number | undefined, created_by_type?: string | undefined, last_update_reason?: string | undefined, record_status?: string | undefined }> | undefined };

export type RentersImplementationFragmentFragment = { __typename?: 'RentersImplementation', id: number, start_date?: string | undefined, min_property_coverage?: number | undefined, min_liability_coverage?: number | undefined };

export type RentersImplementationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RentersImplementationQuery = { __typename?: 'Query', rentersImplementation?: { __typename?: 'RentersImplementation', id: number, start_date?: string | undefined, min_property_coverage?: number | undefined, min_liability_coverage?: number | undefined } | undefined };

export type RentersCoverageConfirmationSaveMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
  input: RentersCoverageConfirmationSaveInput;
  end_date: Scalars['String']['input'];
}>;


export type RentersCoverageConfirmationSaveMutation = { __typename?: 'Mutation', rentersCoverageConfirmationSave: { __typename?: 'SnowflakeRentersPolicy', POLICY_ID: string, INSURANCE_CARRIER: string, INSURANCE_TYPE?: string | undefined, FILE_ID?: number | undefined, FILE_EXT?: string | undefined, ON_CAMPUS: boolean, IS_AUTO_RENEW: boolean, POLICY_NUMBER: string, POLICY_STATUS: SnowFlakeRentersPoliciesRangeDbStatusEnum, POLICY_STATUS_TODAY: SnowFlakeRentersPoliciesRangeDbStatusEnum, SCHOOL_ID: number, SCHOOL_NAME: string, REF_CODE: string, RENTERS_IMPLEMENTATION_ID?: number | undefined, STUDENT_NAME: string, STUDENT_FIRST_NAME: string, STUDENT_LAST_NAME: string, STUDENT_EMAIL: string, STUDENT_PHONE?: string | undefined, STUDENT_EXTERNAL_ID?: string | undefined, PURCHASE_BY?: SnowFlakePolicyRangePurchaseByEnum | undefined, PRIMARY_INSURED_ADDRESS?: string | undefined, PRIMARY_INSURED_CITY?: string | undefined, PRIMARY_INSURED_STATE?: string | undefined, PRIMARY_INSURED_ZIP?: string | undefined, IS_FLAT_CANCEL: boolean, COVERAGE_START_DATE: string, COVERAGE_END_DATE: string, COVERAGE_END_DATE_OR_AUTO_RENEW?: string | undefined, CANCELLATION_DATE?: string | undefined, CANCELLATION_REASON?: string | undefined, CANCELLATION_SOURCE?: string | undefined, CONFIRMATION_NOTE?: string | undefined, PAYMENT_INTERVAL: number, DEDUCTIBLE?: number | undefined, PROPERTY_COVERAGE?: number | undefined, LIABILITY_COVERAGE?: number | undefined, EARTHQUAKE_COVERAGE: number, POLICY_CREATION_TIME: string, ENROLLMENT_DATE?: string | undefined, POLICY_SOURCE?: string | undefined, CREATED_BY?: number | undefined, CREATED_BY_TYPE?: string | undefined, LAST_UPDATE_BY?: number | undefined, LAST_UPDATE_TIME?: string | undefined, LAST_UPDATE_BY_TYPE?: string | undefined, rangeStatus: SnowFlakePolicyRangeStatusEnum, lastUpdateBy?: { __typename?: 'UpdateByUser', id: string, first_name: string, last_name: string } | undefined } };

export type RentersCoverageConfirmationApproveMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
  input: RentersCoverageConfirmationApproveInput;
  end_date: Scalars['String']['input'];
}>;


export type RentersCoverageConfirmationApproveMutation = { __typename?: 'Mutation', rentersCoverageConfirmationApprove: { __typename?: 'SnowflakeRentersPolicy', POLICY_ID: string, INSURANCE_CARRIER: string, INSURANCE_TYPE?: string | undefined, FILE_ID?: number | undefined, FILE_EXT?: string | undefined, ON_CAMPUS: boolean, IS_AUTO_RENEW: boolean, POLICY_NUMBER: string, POLICY_STATUS: SnowFlakeRentersPoliciesRangeDbStatusEnum, POLICY_STATUS_TODAY: SnowFlakeRentersPoliciesRangeDbStatusEnum, SCHOOL_ID: number, SCHOOL_NAME: string, REF_CODE: string, RENTERS_IMPLEMENTATION_ID?: number | undefined, STUDENT_NAME: string, STUDENT_FIRST_NAME: string, STUDENT_LAST_NAME: string, STUDENT_EMAIL: string, STUDENT_PHONE?: string | undefined, STUDENT_EXTERNAL_ID?: string | undefined, PURCHASE_BY?: SnowFlakePolicyRangePurchaseByEnum | undefined, PRIMARY_INSURED_ADDRESS?: string | undefined, PRIMARY_INSURED_CITY?: string | undefined, PRIMARY_INSURED_STATE?: string | undefined, PRIMARY_INSURED_ZIP?: string | undefined, IS_FLAT_CANCEL: boolean, COVERAGE_START_DATE: string, COVERAGE_END_DATE: string, COVERAGE_END_DATE_OR_AUTO_RENEW?: string | undefined, CANCELLATION_DATE?: string | undefined, CANCELLATION_REASON?: string | undefined, CANCELLATION_SOURCE?: string | undefined, CONFIRMATION_NOTE?: string | undefined, PAYMENT_INTERVAL: number, DEDUCTIBLE?: number | undefined, PROPERTY_COVERAGE?: number | undefined, LIABILITY_COVERAGE?: number | undefined, EARTHQUAKE_COVERAGE: number, POLICY_CREATION_TIME: string, ENROLLMENT_DATE?: string | undefined, POLICY_SOURCE?: string | undefined, CREATED_BY?: number | undefined, CREATED_BY_TYPE?: string | undefined, LAST_UPDATE_BY?: number | undefined, LAST_UPDATE_TIME?: string | undefined, LAST_UPDATE_BY_TYPE?: string | undefined, rangeStatus: SnowFlakePolicyRangeStatusEnum, lastUpdateBy?: { __typename?: 'UpdateByUser', id: string, first_name: string, last_name: string } | undefined } };

export type RentersCoverageConfirmationRejectMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  end_date: Scalars['String']['input'];
}>;


export type RentersCoverageConfirmationRejectMutation = { __typename?: 'Mutation', rentersCoverageConfirmationReject: { __typename?: 'SnowflakeRentersPolicy', POLICY_ID: string, INSURANCE_CARRIER: string, INSURANCE_TYPE?: string | undefined, FILE_ID?: number | undefined, FILE_EXT?: string | undefined, ON_CAMPUS: boolean, IS_AUTO_RENEW: boolean, POLICY_NUMBER: string, POLICY_STATUS: SnowFlakeRentersPoliciesRangeDbStatusEnum, POLICY_STATUS_TODAY: SnowFlakeRentersPoliciesRangeDbStatusEnum, SCHOOL_ID: number, SCHOOL_NAME: string, REF_CODE: string, RENTERS_IMPLEMENTATION_ID?: number | undefined, STUDENT_NAME: string, STUDENT_FIRST_NAME: string, STUDENT_LAST_NAME: string, STUDENT_EMAIL: string, STUDENT_PHONE?: string | undefined, STUDENT_EXTERNAL_ID?: string | undefined, PURCHASE_BY?: SnowFlakePolicyRangePurchaseByEnum | undefined, PRIMARY_INSURED_ADDRESS?: string | undefined, PRIMARY_INSURED_CITY?: string | undefined, PRIMARY_INSURED_STATE?: string | undefined, PRIMARY_INSURED_ZIP?: string | undefined, IS_FLAT_CANCEL: boolean, COVERAGE_START_DATE: string, COVERAGE_END_DATE: string, COVERAGE_END_DATE_OR_AUTO_RENEW?: string | undefined, CANCELLATION_DATE?: string | undefined, CANCELLATION_REASON?: string | undefined, CANCELLATION_SOURCE?: string | undefined, CONFIRMATION_NOTE?: string | undefined, PAYMENT_INTERVAL: number, DEDUCTIBLE?: number | undefined, PROPERTY_COVERAGE?: number | undefined, LIABILITY_COVERAGE?: number | undefined, EARTHQUAKE_COVERAGE: number, POLICY_CREATION_TIME: string, ENROLLMENT_DATE?: string | undefined, POLICY_SOURCE?: string | undefined, CREATED_BY?: number | undefined, CREATED_BY_TYPE?: string | undefined, LAST_UPDATE_BY?: number | undefined, LAST_UPDATE_TIME?: string | undefined, LAST_UPDATE_BY_TYPE?: string | undefined, rangeStatus: SnowFlakePolicyRangeStatusEnum, lastUpdateBy?: { __typename?: 'UpdateByUser', id: string, first_name: string, last_name: string } | undefined } };

export type RentersCoverageConfirmationAsPendingMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
  end_date: Scalars['String']['input'];
}>;


export type RentersCoverageConfirmationAsPendingMutation = { __typename?: 'Mutation', rentersCoverageConfirmationAsPending: { __typename?: 'SnowflakeRentersPolicy', POLICY_ID: string, INSURANCE_CARRIER: string, INSURANCE_TYPE?: string | undefined, FILE_ID?: number | undefined, FILE_EXT?: string | undefined, ON_CAMPUS: boolean, IS_AUTO_RENEW: boolean, POLICY_NUMBER: string, POLICY_STATUS: SnowFlakeRentersPoliciesRangeDbStatusEnum, POLICY_STATUS_TODAY: SnowFlakeRentersPoliciesRangeDbStatusEnum, SCHOOL_ID: number, SCHOOL_NAME: string, REF_CODE: string, RENTERS_IMPLEMENTATION_ID?: number | undefined, STUDENT_NAME: string, STUDENT_FIRST_NAME: string, STUDENT_LAST_NAME: string, STUDENT_EMAIL: string, STUDENT_PHONE?: string | undefined, STUDENT_EXTERNAL_ID?: string | undefined, PURCHASE_BY?: SnowFlakePolicyRangePurchaseByEnum | undefined, PRIMARY_INSURED_ADDRESS?: string | undefined, PRIMARY_INSURED_CITY?: string | undefined, PRIMARY_INSURED_STATE?: string | undefined, PRIMARY_INSURED_ZIP?: string | undefined, IS_FLAT_CANCEL: boolean, COVERAGE_START_DATE: string, COVERAGE_END_DATE: string, COVERAGE_END_DATE_OR_AUTO_RENEW?: string | undefined, CANCELLATION_DATE?: string | undefined, CANCELLATION_REASON?: string | undefined, CANCELLATION_SOURCE?: string | undefined, CONFIRMATION_NOTE?: string | undefined, PAYMENT_INTERVAL: number, DEDUCTIBLE?: number | undefined, PROPERTY_COVERAGE?: number | undefined, LIABILITY_COVERAGE?: number | undefined, EARTHQUAKE_COVERAGE: number, POLICY_CREATION_TIME: string, ENROLLMENT_DATE?: string | undefined, POLICY_SOURCE?: string | undefined, CREATED_BY?: number | undefined, CREATED_BY_TYPE?: string | undefined, LAST_UPDATE_BY?: number | undefined, LAST_UPDATE_TIME?: string | undefined, LAST_UPDATE_BY_TYPE?: string | undefined, rangeStatus: SnowFlakePolicyRangeStatusEnum, lastUpdateBy?: { __typename?: 'UpdateByUser', id: string, first_name: string, last_name: string } | undefined } };

export type SnowFlakeRentersDecisionsFragmentFragment = { __typename?: 'SnowFlakeRentersDecisions', purchase: number, billmelater: number, renewal: number, remindmelater: number, none: number, decline: number };

export type SnowflakeRentersDecisionsQueryVariables = Exact<{
  input: SnowFlakeRentersDecisionsInput;
}>;


export type SnowflakeRentersDecisionsQuery = { __typename?: 'Query', snowflakeRentersDecisions: { __typename?: 'SnowFlakeRentersDecisions', purchase: number, billmelater: number, renewal: number, remindmelater: number, none: number, decline: number } };

export type SnowFlakeRentersMonthlyDecisionsPurchaseFragmentFragment = { __typename?: 'SnowFlakeRentersMonthlyDecisionsPurchase', id: string, month: number, year: number, total: number, purchased: number };

export type SnowflakeRentersMonthlyDecisionsPurchaseQueryVariables = Exact<{
  input: SnowFlakeRentersDecisionsInput;
}>;


export type SnowflakeRentersMonthlyDecisionsPurchaseQuery = { __typename?: 'Query', snowflakeRentersMonthlyDecisionsPurchase?: Array<{ __typename?: 'SnowFlakeRentersMonthlyDecisionsPurchase', id: string, month: number, year: number, total: number, purchased: number }> | undefined };

export type SnowflakeRentersPoliciesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
  input: SnowflakeRentersPolicyInput;
  end_date: Scalars['String']['input'];
}>;


export type SnowflakeRentersPoliciesQuery = { __typename?: 'Query', snowflakeRentersPolicies: { __typename?: 'SnowflakeRentersPolicyPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'SnowflakeRentersPolicy', POLICY_ID: string, INSURANCE_CARRIER: string, INSURANCE_TYPE?: string | undefined, FILE_ID?: number | undefined, FILE_EXT?: string | undefined, ON_CAMPUS: boolean, IS_AUTO_RENEW: boolean, POLICY_NUMBER: string, POLICY_STATUS: SnowFlakeRentersPoliciesRangeDbStatusEnum, POLICY_STATUS_TODAY: SnowFlakeRentersPoliciesRangeDbStatusEnum, SCHOOL_ID: number, SCHOOL_NAME: string, REF_CODE: string, RENTERS_IMPLEMENTATION_ID?: number | undefined, STUDENT_NAME: string, STUDENT_FIRST_NAME: string, STUDENT_LAST_NAME: string, STUDENT_EMAIL: string, STUDENT_PHONE?: string | undefined, STUDENT_EXTERNAL_ID?: string | undefined, PURCHASE_BY?: SnowFlakePolicyRangePurchaseByEnum | undefined, PRIMARY_INSURED_ADDRESS?: string | undefined, PRIMARY_INSURED_CITY?: string | undefined, PRIMARY_INSURED_STATE?: string | undefined, PRIMARY_INSURED_ZIP?: string | undefined, IS_FLAT_CANCEL: boolean, COVERAGE_START_DATE: string, COVERAGE_END_DATE: string, COVERAGE_END_DATE_OR_AUTO_RENEW?: string | undefined, CANCELLATION_DATE?: string | undefined, CANCELLATION_REASON?: string | undefined, CANCELLATION_SOURCE?: string | undefined, CONFIRMATION_NOTE?: string | undefined, PAYMENT_INTERVAL: number, DEDUCTIBLE?: number | undefined, PROPERTY_COVERAGE?: number | undefined, LIABILITY_COVERAGE?: number | undefined, EARTHQUAKE_COVERAGE: number, POLICY_CREATION_TIME: string, ENROLLMENT_DATE?: string | undefined, POLICY_SOURCE?: string | undefined, CREATED_BY?: number | undefined, CREATED_BY_TYPE?: string | undefined, LAST_UPDATE_BY?: number | undefined, LAST_UPDATE_TIME?: string | undefined, LAST_UPDATE_BY_TYPE?: string | undefined, rangeStatus: SnowFlakePolicyRangeStatusEnum, lastUpdateBy?: { __typename?: 'UpdateByUser', id: string, first_name: string, last_name: string } | undefined }> } };

export type SnowflakeRentersPolicyQueryVariables = Exact<{
  input: SnowFlakeRentersPolicyInput;
  end_date: Scalars['String']['input'];
}>;


export type SnowflakeRentersPolicyQuery = { __typename?: 'Query', snowflakeRentersPolicy?: { __typename?: 'SnowflakeRentersPolicy', POLICY_ID: string, INSURANCE_CARRIER: string, INSURANCE_TYPE?: string | undefined, FILE_ID?: number | undefined, FILE_EXT?: string | undefined, ON_CAMPUS: boolean, IS_AUTO_RENEW: boolean, POLICY_NUMBER: string, POLICY_STATUS: SnowFlakeRentersPoliciesRangeDbStatusEnum, POLICY_STATUS_TODAY: SnowFlakeRentersPoliciesRangeDbStatusEnum, SCHOOL_ID: number, SCHOOL_NAME: string, REF_CODE: string, RENTERS_IMPLEMENTATION_ID?: number | undefined, STUDENT_NAME: string, STUDENT_FIRST_NAME: string, STUDENT_LAST_NAME: string, STUDENT_EMAIL: string, STUDENT_PHONE?: string | undefined, STUDENT_EXTERNAL_ID?: string | undefined, PURCHASE_BY?: SnowFlakePolicyRangePurchaseByEnum | undefined, PRIMARY_INSURED_ADDRESS?: string | undefined, PRIMARY_INSURED_CITY?: string | undefined, PRIMARY_INSURED_STATE?: string | undefined, PRIMARY_INSURED_ZIP?: string | undefined, IS_FLAT_CANCEL: boolean, COVERAGE_START_DATE: string, COVERAGE_END_DATE: string, COVERAGE_END_DATE_OR_AUTO_RENEW?: string | undefined, CANCELLATION_DATE?: string | undefined, CANCELLATION_REASON?: string | undefined, CANCELLATION_SOURCE?: string | undefined, CONFIRMATION_NOTE?: string | undefined, PAYMENT_INTERVAL: number, DEDUCTIBLE?: number | undefined, PROPERTY_COVERAGE?: number | undefined, LIABILITY_COVERAGE?: number | undefined, EARTHQUAKE_COVERAGE: number, POLICY_CREATION_TIME: string, ENROLLMENT_DATE?: string | undefined, POLICY_SOURCE?: string | undefined, CREATED_BY?: number | undefined, CREATED_BY_TYPE?: string | undefined, LAST_UPDATE_BY?: number | undefined, LAST_UPDATE_TIME?: string | undefined, LAST_UPDATE_BY_TYPE?: string | undefined, rangeStatus: SnowFlakePolicyRangeStatusEnum, lastUpdateBy?: { __typename?: 'UpdateByUser', id: string, first_name: string, last_name: string } | undefined } | undefined };

export type SnowFlakePolicyRentersTrendsFragmentFragment = { __typename?: 'SnowFlakePolicyRentersTrends', PROPERTY: number, EARTHQUAKE: number, LIABILITY: number, DEDUCTIBLE: number, TOTAL: number, POLICIES: number };

export type SnowflakePolicyRentersTrendsQueryVariables = Exact<{
  input: SnowFlakePolicyStatsInput;
}>;


export type SnowflakePolicyRentersTrendsQuery = { __typename?: 'Query', snowflakePolicyRentersTrends?: { __typename?: 'SnowFlakePolicyRentersTrends', PROPERTY: number, EARTHQUAKE: number, LIABILITY: number, DEDUCTIBLE: number, TOTAL: number, POLICIES: number } | undefined };

export type SnowFlakePolicyCoveredFragmentFragment = { __typename?: 'SnowFlakePolicyCovered', activeInRange: number, range_status_active: number, range_status_pending: number, range_status_other: number, range_purchases: number, total: number, school_id: number, schoolCapacity: number };

export type SnowflakePolicyRentersCoveredQueryVariables = Exact<{
  input: SnowFlakePolicyStatsInput;
}>;


export type SnowflakePolicyRentersCoveredQuery = { __typename?: 'Query', snowflakePolicyRentersCovered?: { __typename?: 'SnowFlakePolicyCovered', activeInRange: number, range_status_active: number, range_status_pending: number, range_status_other: number, range_purchases: number, total: number, school_id: number, schoolCapacity: number } | undefined };

export type UpdateByUserFragmentFragment = { __typename?: 'UpdateByUser', id: string, first_name: string, last_name: string };

export type SnowflakeRentersPolicyFragmentFragment = { __typename?: 'SnowflakeRentersPolicy', POLICY_ID: string, INSURANCE_CARRIER: string, INSURANCE_TYPE?: string | undefined, FILE_ID?: number | undefined, FILE_EXT?: string | undefined, ON_CAMPUS: boolean, IS_AUTO_RENEW: boolean, POLICY_NUMBER: string, POLICY_STATUS: SnowFlakeRentersPoliciesRangeDbStatusEnum, POLICY_STATUS_TODAY: SnowFlakeRentersPoliciesRangeDbStatusEnum, SCHOOL_ID: number, SCHOOL_NAME: string, REF_CODE: string, RENTERS_IMPLEMENTATION_ID?: number | undefined, STUDENT_NAME: string, STUDENT_FIRST_NAME: string, STUDENT_LAST_NAME: string, STUDENT_EMAIL: string, STUDENT_PHONE?: string | undefined, STUDENT_EXTERNAL_ID?: string | undefined, PURCHASE_BY?: SnowFlakePolicyRangePurchaseByEnum | undefined, PRIMARY_INSURED_ADDRESS?: string | undefined, PRIMARY_INSURED_CITY?: string | undefined, PRIMARY_INSURED_STATE?: string | undefined, PRIMARY_INSURED_ZIP?: string | undefined, IS_FLAT_CANCEL: boolean, COVERAGE_START_DATE: string, COVERAGE_END_DATE: string, COVERAGE_END_DATE_OR_AUTO_RENEW?: string | undefined, CANCELLATION_DATE?: string | undefined, CANCELLATION_REASON?: string | undefined, CANCELLATION_SOURCE?: string | undefined, CONFIRMATION_NOTE?: string | undefined, PAYMENT_INTERVAL: number, DEDUCTIBLE?: number | undefined, PROPERTY_COVERAGE?: number | undefined, LIABILITY_COVERAGE?: number | undefined, EARTHQUAKE_COVERAGE: number, POLICY_CREATION_TIME: string, ENROLLMENT_DATE?: string | undefined, POLICY_SOURCE?: string | undefined, CREATED_BY?: number | undefined, CREATED_BY_TYPE?: string | undefined, LAST_UPDATE_BY?: number | undefined, LAST_UPDATE_TIME?: string | undefined, LAST_UPDATE_BY_TYPE?: string | undefined, rangeStatus: SnowFlakePolicyRangeStatusEnum, lastUpdateBy?: { __typename?: 'UpdateByUser', id: string, first_name: string, last_name: string } | undefined };

export type SnowFlakeRefundAcknowledgmentVuFragmentFragment = { __typename?: 'SnowFlakeRefundAcknowledgmentVu', QUICK_USER_ID?: number | undefined, STUDENT_ID?: string | undefined, STUDENT_NAME?: string | undefined, STUDENT_FIRST_NAME?: string | undefined, STUDENT_LAST_NAME?: string | undefined, STUDENT_EMAIL?: string | undefined, WHO_HAS_ACKNOWLEDGED?: string | undefined, MOST_RECENT_ACKNOWLEDGEMENT_TIME?: string | undefined, MOST_RECENT_REFUND_POLICY_CONTENT?: string | undefined, QU_POLICY_NUMBER?: string | undefined, POLICY_NUMBER?: string | undefined, ENROLLMENT_DATE?: string | undefined, combinedRefundPolicyFlow?: Array<{ __typename?: 'RefundPolicyFlow', date: string, description: string, refund_policy_id: number, uuid: string }> | undefined };

export type RefundPolicyFlowFragmentFragment = { __typename?: 'RefundPolicyFlow', date: string, description: string, refund_policy_id: number, uuid: string };

export type SnowflakeRefundAcknowledgmentVuSearchQueryVariables = Exact<{
  input: SnowFlakeRefundAcknowledgementVuSearchInput;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SnowflakeRefundAcknowledgmentVuSearchQuery = { __typename?: 'Query', snowflakeRefundAcknowledgmentVuSearch: { __typename?: 'SnowFlakeRefundAcknowledgmentVuPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'SnowFlakeRefundAcknowledgmentVu', QUICK_USER_ID?: number | undefined, STUDENT_ID?: string | undefined, STUDENT_NAME?: string | undefined, STUDENT_FIRST_NAME?: string | undefined, STUDENT_LAST_NAME?: string | undefined, STUDENT_EMAIL?: string | undefined, WHO_HAS_ACKNOWLEDGED?: string | undefined, MOST_RECENT_ACKNOWLEDGEMENT_TIME?: string | undefined, MOST_RECENT_REFUND_POLICY_CONTENT?: string | undefined, QU_POLICY_NUMBER?: string | undefined, POLICY_NUMBER?: string | undefined, ENROLLMENT_DATE?: string | undefined, combinedRefundPolicyFlow?: Array<{ __typename?: 'RefundPolicyFlow', date: string, description: string, refund_policy_id: number, uuid: string }> | undefined }> } };

export type SnowFlakeTuitionDecisionsFragmentFragment = { __typename?: 'SnowFlakeTuitionDecisions', purchase: number, accept: number, remindmelater: number, decline: number };

export type SnowflakeTuitionDecisionsQueryVariables = Exact<{
  input: SnowFlakeTuitionDecisionsInput;
}>;


export type SnowflakeTuitionDecisionsQuery = { __typename?: 'Query', snowflakeTuitionDecisions: { __typename?: 'SnowFlakeTuitionDecisions', purchase: number, accept: number, remindmelater: number, decline: number } };

export type SnowFlakeTuitionMonthlyDecisionsPurchaseFragmentFragment = { __typename?: 'SnowFlakeTuitionMonthlyDecisionsPurchase', id: string, month: number, year: number, total: number, purchased: number };

export type SnowflakeTuitionMonthlyDecisionsPurchaseQueryVariables = Exact<{
  input: SnowFlakeTuitionDecisionsInput;
}>;


export type SnowflakeTuitionMonthlyDecisionsPurchaseQuery = { __typename?: 'Query', snowflakeTuitionMonthlyDecisionsPurchase?: Array<{ __typename?: 'SnowFlakeTuitionMonthlyDecisionsPurchase', id: string, month: number, year: number, total: number, purchased: number }> | undefined };

export type SnowflakeTuitionPoliciesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
  input: SnowflakeTuitionPolicyInput;
  end_date: Scalars['String']['input'];
}>;


export type SnowflakeTuitionPoliciesQuery = { __typename?: 'Query', snowflakeTuitionPolicies: { __typename?: 'SnowflakeTuitionPolicyPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'SnowflakeTuitionPolicy', POLICY_NUMBER: string, POLICY_ID: number, POLICY_CREATION_TIME?: string | undefined, ENROLLMENT_DATE?: string | undefined, POLICY_SOURCE?: string | undefined, START_DATE: string, END_DATE: string, DAYS_COVERED?: number | undefined, POLICY_STATUS?: SnowflakeTuitionRangeDbStatusEnum | undefined, SCHOOL_NAME?: string | undefined, SCHOOL_ID?: number | undefined, REF_CODE?: string | undefined, TUITION_IMPLEMENTATION_ID?: number | undefined, PAYMENT_GATEWAY?: string | undefined, PROGRAM_TYPE?: string | undefined, PRICE?: number | undefined, IS_PAID?: boolean | undefined, AMOUNT_PAID?: number | undefined, IS_REFUNDED?: boolean | undefined, AMOUNT_REFUNDED?: number | undefined, REFUND_MORE_THAN_PRICE?: boolean | undefined, NUM_REFUNDS?: number | undefined, PAYMENT_STATUS?: string | undefined, CHARGE_DATE?: string | undefined, REFUND_TIME?: string | undefined, COVERAGE_AMOUNT: number, YEARLY_GOAL_ASSIGNED_TO?: string | undefined, TERM_GOAL_ASSIGNED_TO?: string | undefined, MEMBERSHIP_ID?: number | undefined, ENTITY_ID?: number | undefined, INSURED_NAME: string, INSURED_FIRST_NAME: string, INSURED_LAST_NAME: string, INSURED_PHONE?: string | undefined, INSURED_EMAIL: string, INSURED_ADDRESS: string, INSURED_CITY: string, INSURED_STATE: string, INSURED_ZIP: string, IS_ON_CAMPUS: boolean, ACCOUNT_OWNER_NAME?: string | undefined, ACCOUNT_OWNER_PHONE?: string | undefined, ACCOUNT_HOLDER_EMAIL?: string | undefined, IS_PURCHASED_BY_STUDENT?: boolean | undefined, TERM_AND_SEASON?: string | undefined, CALENDAR_TERM?: string | undefined, IMPLEMENTATION_TERM?: string | undefined, IMPLEMENTATION_SEASON?: string | undefined, OFFER_OPEN_DATE?: string | undefined, DAYS_SINCE_OFFER_OPEN?: number | undefined, DAYS_SINCE_BILL_DATE?: number | undefined, DAYS_SINCE_BILL_DATE_DUE?: number | undefined, DAYS_BEFORE_TERM_START?: number | undefined, CANCELLATION_DATE?: string | undefined, CANCELLATION_REASON?: string | undefined, CANCELLATION_SOURCE?: string | undefined, IS_FLAT_CANCEL?: boolean | undefined, PAYMENT_TRANSACTION_ID?: number | undefined, INSURED_EXTERNAL_ID?: string | undefined, rangeStatus: SnowflakeTuitionRangeStatusEnum }> } };

export type SnowflakeTuitionPolicyQueryVariables = Exact<{
  input: SnowFlakeTuitionPolicyInput;
  end_date: Scalars['String']['input'];
}>;


export type SnowflakeTuitionPolicyQuery = { __typename?: 'Query', snowflakeTuitionPolicy?: { __typename?: 'SnowflakeTuitionPolicy', POLICY_NUMBER: string, POLICY_ID: number, POLICY_CREATION_TIME?: string | undefined, ENROLLMENT_DATE?: string | undefined, POLICY_SOURCE?: string | undefined, START_DATE: string, END_DATE: string, DAYS_COVERED?: number | undefined, POLICY_STATUS?: SnowflakeTuitionRangeDbStatusEnum | undefined, SCHOOL_NAME?: string | undefined, SCHOOL_ID?: number | undefined, REF_CODE?: string | undefined, TUITION_IMPLEMENTATION_ID?: number | undefined, PAYMENT_GATEWAY?: string | undefined, PROGRAM_TYPE?: string | undefined, PRICE?: number | undefined, IS_PAID?: boolean | undefined, AMOUNT_PAID?: number | undefined, IS_REFUNDED?: boolean | undefined, AMOUNT_REFUNDED?: number | undefined, REFUND_MORE_THAN_PRICE?: boolean | undefined, NUM_REFUNDS?: number | undefined, PAYMENT_STATUS?: string | undefined, CHARGE_DATE?: string | undefined, REFUND_TIME?: string | undefined, COVERAGE_AMOUNT: number, YEARLY_GOAL_ASSIGNED_TO?: string | undefined, TERM_GOAL_ASSIGNED_TO?: string | undefined, MEMBERSHIP_ID?: number | undefined, ENTITY_ID?: number | undefined, INSURED_NAME: string, INSURED_FIRST_NAME: string, INSURED_LAST_NAME: string, INSURED_PHONE?: string | undefined, INSURED_EMAIL: string, INSURED_ADDRESS: string, INSURED_CITY: string, INSURED_STATE: string, INSURED_ZIP: string, IS_ON_CAMPUS: boolean, ACCOUNT_OWNER_NAME?: string | undefined, ACCOUNT_OWNER_PHONE?: string | undefined, ACCOUNT_HOLDER_EMAIL?: string | undefined, IS_PURCHASED_BY_STUDENT?: boolean | undefined, TERM_AND_SEASON?: string | undefined, CALENDAR_TERM?: string | undefined, IMPLEMENTATION_TERM?: string | undefined, IMPLEMENTATION_SEASON?: string | undefined, OFFER_OPEN_DATE?: string | undefined, DAYS_SINCE_OFFER_OPEN?: number | undefined, DAYS_SINCE_BILL_DATE?: number | undefined, DAYS_SINCE_BILL_DATE_DUE?: number | undefined, DAYS_BEFORE_TERM_START?: number | undefined, CANCELLATION_DATE?: string | undefined, CANCELLATION_REASON?: string | undefined, CANCELLATION_SOURCE?: string | undefined, IS_FLAT_CANCEL?: boolean | undefined, PAYMENT_TRANSACTION_ID?: number | undefined, INSURED_EXTERNAL_ID?: string | undefined, rangeStatus: SnowflakeTuitionRangeStatusEnum } | undefined };

export type SnowFlakePolicyTuitionTrendsFragmentFragment = { __typename?: 'SnowFlakePolicyTuitionTrends', TOTAL: number, AVERAGE: number, POLICIES: number };

export type SnowflakePolicyTuitionTrendsQueryVariables = Exact<{
  input: SnowFlakeTuitionPolicyStatsInput;
}>;


export type SnowflakePolicyTuitionTrendsQuery = { __typename?: 'Query', snowflakePolicyTuitionTrends?: { __typename?: 'SnowFlakePolicyTuitionTrends', TOTAL: number, AVERAGE: number, POLICIES: number } | undefined };

export type SnowFlakeTuitionPolicyCoveredFragmentFragment = { __typename?: 'SnowFlakeTuitionPolicyCovered', activeInRange: number, range_status_active: number, range_status_pending: number, range_status_other: number, range_purchases: number, total: number, school_id: number, schoolCapacity: number };

export type SnowflakePolicyTuitionCoveredQueryVariables = Exact<{
  input: SnowFlakeTuitionPolicyStatsInput;
}>;


export type SnowflakePolicyTuitionCoveredQuery = { __typename?: 'Query', snowflakePolicyTuitionCovered?: { __typename?: 'SnowFlakeTuitionPolicyCovered', activeInRange: number, range_status_active: number, range_status_pending: number, range_status_other: number, range_purchases: number, total: number, school_id: number, schoolCapacity: number } | undefined };

export type SnowflakeTuitionPolicyFragmentFragment = { __typename?: 'SnowflakeTuitionPolicy', POLICY_NUMBER: string, POLICY_ID: number, POLICY_CREATION_TIME?: string | undefined, ENROLLMENT_DATE?: string | undefined, POLICY_SOURCE?: string | undefined, START_DATE: string, END_DATE: string, DAYS_COVERED?: number | undefined, POLICY_STATUS?: SnowflakeTuitionRangeDbStatusEnum | undefined, SCHOOL_NAME?: string | undefined, SCHOOL_ID?: number | undefined, REF_CODE?: string | undefined, TUITION_IMPLEMENTATION_ID?: number | undefined, PAYMENT_GATEWAY?: string | undefined, PROGRAM_TYPE?: string | undefined, PRICE?: number | undefined, IS_PAID?: boolean | undefined, AMOUNT_PAID?: number | undefined, IS_REFUNDED?: boolean | undefined, AMOUNT_REFUNDED?: number | undefined, REFUND_MORE_THAN_PRICE?: boolean | undefined, NUM_REFUNDS?: number | undefined, PAYMENT_STATUS?: string | undefined, CHARGE_DATE?: string | undefined, REFUND_TIME?: string | undefined, COVERAGE_AMOUNT: number, YEARLY_GOAL_ASSIGNED_TO?: string | undefined, TERM_GOAL_ASSIGNED_TO?: string | undefined, MEMBERSHIP_ID?: number | undefined, ENTITY_ID?: number | undefined, INSURED_NAME: string, INSURED_FIRST_NAME: string, INSURED_LAST_NAME: string, INSURED_PHONE?: string | undefined, INSURED_EMAIL: string, INSURED_ADDRESS: string, INSURED_CITY: string, INSURED_STATE: string, INSURED_ZIP: string, IS_ON_CAMPUS: boolean, ACCOUNT_OWNER_NAME?: string | undefined, ACCOUNT_OWNER_PHONE?: string | undefined, ACCOUNT_HOLDER_EMAIL?: string | undefined, IS_PURCHASED_BY_STUDENT?: boolean | undefined, TERM_AND_SEASON?: string | undefined, CALENDAR_TERM?: string | undefined, IMPLEMENTATION_TERM?: string | undefined, IMPLEMENTATION_SEASON?: string | undefined, OFFER_OPEN_DATE?: string | undefined, DAYS_SINCE_OFFER_OPEN?: number | undefined, DAYS_SINCE_BILL_DATE?: number | undefined, DAYS_SINCE_BILL_DATE_DUE?: number | undefined, DAYS_BEFORE_TERM_START?: number | undefined, CANCELLATION_DATE?: string | undefined, CANCELLATION_REASON?: string | undefined, CANCELLATION_SOURCE?: string | undefined, IS_FLAT_CANCEL?: boolean | undefined, PAYMENT_TRANSACTION_ID?: number | undefined, INSURED_EXTERNAL_ID?: string | undefined, rangeStatus: SnowflakeTuitionRangeStatusEnum };

export type TermsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
  input: TermsInput;
}>;


export type TermsQuery = { __typename?: 'Query', terms: { __typename?: 'RefCodeTermPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'RefCodeTerm', id: number, uuid?: string | undefined, ref_code_id: number, term_name: string, term_start?: any | undefined, term_end?: any | undefined, offer_open_date?: any | undefined }> } };

export type TuitionImplementationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
  input: TuitionImplementationInput;
}>;


export type TuitionImplementationsQuery = { __typename?: 'Query', tuitionImplementations: { __typename?: 'TuitionImplementationPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'TuitionImplementation', id: number, season: string, term: string, effective_date?: string | undefined, payment_gateway?: string | undefined, ref_code_id: number }> } };

export type WaiverCategoryCreateMutationVariables = Exact<{
  partner_id: Scalars['Int']['input'];
  input: WaiverCategoryInput;
}>;


export type WaiverCategoryCreateMutation = { __typename?: 'Mutation', waiverCategoryCreate: { __typename?: 'WaiverCategory', uuid: string, partner_id: number, name: string, desc?: string | undefined, status: WaiverCategoryStatus, is_global: boolean, is_editable: boolean, total_users: number, portal_contact_ids: Array<number> } };

export type WaiverCategoryUpdateMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  input: WaiverCategoryInput;
}>;


export type WaiverCategoryUpdateMutation = { __typename?: 'Mutation', waiverCategoryUpdate: { __typename?: 'WaiverCategory', uuid: string, partner_id: number, name: string, desc?: string | undefined, status: WaiverCategoryStatus, is_global: boolean, is_editable: boolean, total_users: number, portal_contact_ids: Array<number> } };

export type WaiverCategoryStatusUpdateMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  status: WaiverCategoryStatus;
}>;


export type WaiverCategoryStatusUpdateMutation = { __typename?: 'Mutation', waiverCategoryStatusUpdate: { __typename?: 'WaiverCategory', uuid: string, partner_id: number, name: string, desc?: string | undefined, status: WaiverCategoryStatus, is_global: boolean, is_editable: boolean, total_users: number, portal_contact_ids: Array<number> } };

export type WaiverCategoryContactsUpdateMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  portal_contact_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type WaiverCategoryContactsUpdateMutation = { __typename?: 'Mutation', waiverCategoryContactsUpdate: { __typename?: 'WaiverCategory', uuid: string, partner_id: number, name: string, desc?: string | undefined, status: WaiverCategoryStatus, is_global: boolean, is_editable: boolean, total_users: number, portal_contact_ids: Array<number> } };

export type WaiverCategoryUserUpdateMutationVariables = Exact<{
  portal_contact_id: Scalars['Int']['input'];
  partner_id: Scalars['Int']['input'];
  waiver_category_uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type WaiverCategoryUserUpdateMutation = { __typename?: 'Mutation', waiverCategoryUserUpdate: { __typename?: 'PortalContact', id: number, first_name: string, last_name: string, preferred_name?: string | undefined, waiverCategories: Array<{ __typename?: 'WaiverCategory', uuid: string, name: string }> } };

export type WaiverContentCreateMutationVariables = Exact<{
  partner_id: Scalars['Int']['input'];
  input: WaiverContentInput;
}>;


export type WaiverContentCreateMutation = { __typename?: 'Mutation', waiverContentCreate: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } };

export type WaiverContentUpdateMutationVariables = Exact<{
  group_uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  input: WaiverContentInput;
}>;


export type WaiverContentUpdateMutation = { __typename?: 'Mutation', waiverContentUpdate: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } };

export type WaiverContentStatusUpdateMutationVariables = Exact<{
  group_uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  status: WaiverContentStatus;
}>;


export type WaiverContentStatusUpdateMutation = { __typename?: 'Mutation', waiverContentStatusUpdate: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } };

export type WaiverFormCreateMutationVariables = Exact<{
  partner_id: Scalars['Int']['input'];
  input: WaiverFormInput;
}>;


export type WaiverFormCreateMutation = { __typename?: 'Mutation', waiverFormCreate: { __typename?: 'WaiverForm', uuid: string, group_uuid: string, waiver_template_uuid: string, name: string, live_start_date: any, live_end_date: any, status: WaiverFormStatus, last_interaction_by_name?: string | undefined, last_interaction_time: any, template: { __typename?: 'WaiverTemplate', uuid: string, label: string, period: WaiverTemplatePeriod, status: WaiverTemplateStatus, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }> }, currentTemplate?: { __typename?: 'WaiverTemplate', uuid: string, label: string, period: WaiverTemplatePeriod, status: WaiverTemplateStatus, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }> } | undefined, fields: Array<{ __typename?: 'WaiverFormField', uuid: string, value?: string | undefined, format?: string | undefined, waiver_template_item_field_uuid: string, templateItemField: { __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType } }> } };

export type WaiverFormUpdateMutationVariables = Exact<{
  group_uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  input: WaiverFormInput;
  status?: InputMaybe<WaiverFormStatus>;
}>;


export type WaiverFormUpdateMutation = { __typename?: 'Mutation', waiverFormUpdate: { __typename?: 'WaiverForm', uuid: string, group_uuid: string, waiver_template_uuid: string, name: string, live_start_date: any, live_end_date: any, status: WaiverFormStatus, last_interaction_by_name?: string | undefined, last_interaction_time: any, template: { __typename?: 'WaiverTemplate', uuid: string, label: string, period: WaiverTemplatePeriod, status: WaiverTemplateStatus, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }> }, currentTemplate?: { __typename?: 'WaiverTemplate', uuid: string, label: string, period: WaiverTemplatePeriod, status: WaiverTemplateStatus, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }> } | undefined, fields: Array<{ __typename?: 'WaiverFormField', uuid: string, value?: string | undefined, format?: string | undefined, waiver_template_item_field_uuid: string, templateItemField: { __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType } }> } };

export type WaiverFormStatusUpdateMutationVariables = Exact<{
  group_uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  status: WaiverFormStatus;
}>;


export type WaiverFormStatusUpdateMutation = { __typename?: 'Mutation', waiverFormStatusUpdate: { __typename?: 'WaiverForm', uuid: string, group_uuid: string, waiver_template_uuid: string, name: string, live_start_date: any, live_end_date: any, status: WaiverFormStatus, last_interaction_by_name?: string | undefined, last_interaction_time: any, template: { __typename?: 'WaiverTemplate', uuid: string, label: string, period: WaiverTemplatePeriod, status: WaiverTemplateStatus, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }> }, currentTemplate?: { __typename?: 'WaiverTemplate', uuid: string, label: string, period: WaiverTemplatePeriod, status: WaiverTemplateStatus, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, type: WaiverTemplateItemType, position: number, payload?: string | undefined, question_required?: boolean | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined, fields: Array<{ __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType }> }> } | undefined, fields: Array<{ __typename?: 'WaiverFormField', uuid: string, value?: string | undefined, format?: string | undefined, waiver_template_item_field_uuid: string, templateItemField: { __typename?: 'WaiverTemplateItemField', uuid: string, name: string, type: WaiverTemplateItemFieldType } }> } };

export type WaiverFormSubmissionCreateMutationVariables = Exact<{
  partner_id: Scalars['Int']['input'];
  input: WaiverFormSubmissionInput;
}>;


export type WaiverFormSubmissionCreateMutation = { __typename?: 'Mutation', waiverFormSubmissionCreate: { __typename?: 'WaiverFormSubmission', uuid: string, form_uuid: string, is_test: boolean } };

export type WaiverListCreateMutationVariables = Exact<{
  partner_id: Scalars['Int']['input'];
  input: WaiverListInput;
}>;


export type WaiverListCreateMutation = { __typename?: 'Mutation', waiverListCreate: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } };

export type WaiverListUpdateMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  input: WaiverListInput;
}>;


export type WaiverListUpdateMutation = { __typename?: 'Mutation', waiverListUpdate: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } };

export type WaiverListStatusUpdateMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  status: WaiverListStatus;
}>;


export type WaiverListStatusUpdateMutation = { __typename?: 'Mutation', waiverListStatusUpdate: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } };

export type WaiverQuestionCreateMutationVariables = Exact<{
  partner_id: Scalars['Int']['input'];
  input: WaiverQuestionInput;
}>;


export type WaiverQuestionCreateMutation = { __typename?: 'Mutation', waiverQuestionCreate: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } };

export type WaiverQuestionUpdateMutationVariables = Exact<{
  group_uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  input: WaiverQuestionInput;
}>;


export type WaiverQuestionUpdateMutation = { __typename?: 'Mutation', waiverQuestionUpdate: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } };

export type WaiverQuestionStatusUpdateMutationVariables = Exact<{
  group_uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  status: WaiverQuestionStatus;
}>;


export type WaiverQuestionStatusUpdateMutation = { __typename?: 'Mutation', waiverQuestionStatusUpdate: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } };

export type WaiverTemplateCreateMutationVariables = Exact<{
  partner_id: Scalars['Int']['input'];
  input: WaiverTemplateInput;
}>;


export type WaiverTemplateCreateMutation = { __typename?: 'Mutation', waiverTemplateCreate: { __typename?: 'WaiverTemplate', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, period: WaiverTemplatePeriod, type: WaiverTemplateType, status: WaiverTemplateStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }> } };

export type WaiverTemplateUpdateMutationVariables = Exact<{
  group_uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  input: WaiverTemplateInput;
}>;


export type WaiverTemplateUpdateMutation = { __typename?: 'Mutation', waiverTemplateUpdate: { __typename?: 'WaiverTemplate', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, period: WaiverTemplatePeriod, type: WaiverTemplateType, status: WaiverTemplateStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }> } };

export type WaiverTemplateStatusUpdateMutationVariables = Exact<{
  group_uuid: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  status: WaiverTemplateStatus;
}>;


export type WaiverTemplateStatusUpdateMutation = { __typename?: 'Mutation', waiverTemplateStatusUpdate: { __typename?: 'WaiverTemplate', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, period: WaiverTemplatePeriod, type: WaiverTemplateType, status: WaiverTemplateStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined, category: { __typename?: 'WaiverCategory', uuid: string, name: string }, items: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, children: Array<{ __typename?: 'WaiverTemplateItem', uuid: string, waiver_template_uuid: string, parent_item_uuid?: string | undefined, type: WaiverTemplateItemType, position: number, payload?: string | undefined, waiver_question_uuid?: string | undefined, question_required?: boolean | undefined, waiver_content_uuid?: string | undefined, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }>, question?: { __typename?: 'WaiverQuestion', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, short_name: string, name: string, type_id: WaiverQuestionType, waiver_list_uuid?: string | undefined, is_editable: boolean, status: WaiverQuestionStatus, required_for_types: Array<WaiverTemplateType>, list?: { __typename?: 'WaiverList', uuid: string, partner_id: number, label: string, status: WaiverListStatus, options: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, activeOptions: Array<{ __typename?: 'WaiverListOption', uuid: string, waiver_list_uuid: string, label: string, value: string, sort_order: number, status: WaiverListStatus }>, questions: Array<{ __typename?: 'WaiverQuestion', uuid: string, short_name: string }> } | undefined } | undefined, content?: { __typename?: 'WaiverContent', uuid: string, group_uuid: string, waiver_category_uuid: string, label: string, html: string, status: WaiverContentStatus, creation_time: any, created_by_name?: string | undefined, last_update_time: any, last_interaction_time: any, last_interaction_by_name?: string | undefined } | undefined }> } };

export type ZdTicketFragmentFragment = { __typename?: 'ZDTicket', url?: string | undefined, id: number, created_at: string, updated_at?: string | undefined, type?: ZdTicketType | undefined, subject?: string | undefined, raw_subject?: string | undefined, description?: string | undefined, status: ZdTicketPriority, recipient?: string | undefined, requester_id?: number | undefined, submitter_id?: number | undefined, assignee_id?: number | undefined, organization_id?: number | undefined, group_id?: number | undefined, has_incidents?: boolean | undefined, is_public?: boolean | undefined, due_at?: string | undefined, ticket_form_id?: number | undefined, brand_id?: number | undefined, allow_channelback?: boolean | undefined, allow_attachments?: boolean | undefined, from_messaging_channel?: boolean | undefined };

export type ZdTicketCommentFragmentFragment = { __typename?: 'ZDTicketComment', id: number, author_id: number, public: boolean, audit_id?: number | undefined, body?: string | undefined, html_body?: string | undefined, plain_body?: string | undefined, created_at: string };

export type ZdTicketsQueryVariables = Exact<{
  input?: InputMaybe<ZdTicketsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ZdTicketsQuery = { __typename?: 'Query', zdTickets: { __typename?: 'ZDTicketPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'ZDTicket', url?: string | undefined, id: number, created_at: string, updated_at?: string | undefined, type?: ZdTicketType | undefined, subject?: string | undefined, raw_subject?: string | undefined, description?: string | undefined, status: ZdTicketPriority, recipient?: string | undefined, requester_id?: number | undefined, submitter_id?: number | undefined, assignee_id?: number | undefined, organization_id?: number | undefined, group_id?: number | undefined, has_incidents?: boolean | undefined, is_public?: boolean | undefined, due_at?: string | undefined, ticket_form_id?: number | undefined, brand_id?: number | undefined, allow_channelback?: boolean | undefined, allow_attachments?: boolean | undefined, from_messaging_channel?: boolean | undefined }> } };

export type ZdTicketQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ZdTicketQuery = { __typename?: 'Query', zdTicket?: { __typename?: 'ZDTicketUser', ticket?: { __typename?: 'ZDTicket', url?: string | undefined, id: number, created_at: string, updated_at?: string | undefined, type?: ZdTicketType | undefined, subject?: string | undefined, raw_subject?: string | undefined, description?: string | undefined, status: ZdTicketPriority, recipient?: string | undefined, requester_id?: number | undefined, submitter_id?: number | undefined, assignee_id?: number | undefined, organization_id?: number | undefined, group_id?: number | undefined, has_incidents?: boolean | undefined, is_public?: boolean | undefined, due_at?: string | undefined, ticket_form_id?: number | undefined, brand_id?: number | undefined, allow_channelback?: boolean | undefined, allow_attachments?: boolean | undefined, from_messaging_channel?: boolean | undefined } | undefined, users: Array<{ __typename?: 'ZDUser', id: number, name: string, email: string, created_at: string }> } | undefined };

export type ZdTicketCommentsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ZdTicketCommentsQuery = { __typename?: 'Query', zdTicketComments: { __typename?: 'ZDTicketComments', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, comments: Array<{ __typename?: 'ZDTicketComment', id: number, author_id: number, public: boolean, audit_id?: number | undefined, body?: string | undefined, html_body?: string | undefined, plain_body?: string | undefined, created_at: string }>, users: Array<{ __typename?: 'ZDUser', id: number, name: string, email: string, created_at: string }> } };

export type ZdTicketCreateMutationVariables = Exact<{
  body: Scalars['String']['input'];
  subject: Scalars['String']['input'];
}>;


export type ZdTicketCreateMutation = { __typename?: 'Mutation', zdTicketCreate?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type ZdTicketCommentCreateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  body: Scalars['String']['input'];
}>;


export type ZdTicketCommentCreateMutation = { __typename?: 'Mutation', zdTicketCommentCreate?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type ZdUserFragmentFragment = { __typename?: 'ZDUser', id: number, name: string, email: string, created_at: string };

export const PortalContactSelectFragmentFragmentDoc = gql`
    fragment PortalContactSelectFragment on PortalContact {
  id
  first_name
  last_name
}
    `;
export const WaiverCategoryFragmentFragmentDoc = gql`
    fragment WaiverCategoryFragment on WaiverCategory {
  uuid
  partner_id
  name
  desc
  status
  is_global
  is_editable
  total_users
  portal_contact_ids
}
    `;
export const WaiverCategoryUserFragmentFragmentDoc = gql`
    fragment WaiverCategoryUserFragment on PortalContact {
  id
  first_name
  last_name
  preferred_name
  waiverCategories(partner_id: $partner_id) {
    uuid
    name
  }
}
    `;
export const WaiverFormFragmentFragmentDoc = gql`
    fragment WaiverFormFragment on WaiverForm {
  uuid
  group_uuid
  waiver_template_uuid
  name
  live_start_date
  live_end_date
  status
  displayStatus
  submissions_count
  last_interaction_by_name
  last_update_time
  template {
    uuid
    label
    period
    category {
      uuid
      name
    }
  }
}
    `;
export const WaiverListOptionFragmentFragmentDoc = gql`
    fragment WaiverListOptionFragment on WaiverListOption {
  uuid
  waiver_list_uuid
  label
  value
  sort_order
  status
}
    `;
export const WaiverListFragmentFragmentDoc = gql`
    fragment WaiverListFragment on WaiverList {
  uuid
  partner_id
  label
  status
  options {
    ...WaiverListOptionFragment
  }
  activeOptions {
    ...WaiverListOptionFragment
  }
  questions {
    uuid
    short_name
  }
}
    ${WaiverListOptionFragmentFragmentDoc}`;
export const WaiverQuestionFragmentFragmentDoc = gql`
    fragment WaiverQuestionFragment on WaiverQuestion {
  uuid
  group_uuid
  waiver_category_uuid
  label
  short_name
  name
  type_id
  waiver_list_uuid
  is_editable
  status
  required_for_types
  list {
    ...WaiverListFragment
  }
}
    ${WaiverListFragmentFragmentDoc}`;
export const WaiverContentFragmentFragmentDoc = gql`
    fragment WaiverContentFragment on WaiverContent {
  uuid
  group_uuid
  waiver_category_uuid
  label
  html
  status
  creation_time
  created_by_name
  last_update_time
  last_interaction_time
  last_interaction_by_name
}
    `;
export const WaiverFormItemFieldFragmentFragmentDoc = gql`
    fragment WaiverFormItemFieldFragment on WaiverTemplateItemField {
  uuid
  name
  type
}
    `;
export const WaiverFormTemplateItemNestedFragmentFragmentDoc = gql`
    fragment WaiverFormTemplateItemNestedFragment on WaiverTemplateItem {
  uuid
  type
  position
  payload
  question_required
  question {
    ...WaiverQuestionFragment
  }
  content {
    ...WaiverContentFragment
  }
  fields {
    ...WaiverFormItemFieldFragment
  }
}
    ${WaiverQuestionFragmentFragmentDoc}
${WaiverContentFragmentFragmentDoc}
${WaiverFormItemFieldFragmentFragmentDoc}`;
export const WaiverFormTemplateItemFragmentFragmentDoc = gql`
    fragment WaiverFormTemplateItemFragment on WaiverTemplateItem {
  ...WaiverFormTemplateItemNestedFragment
  children {
    ...WaiverFormTemplateItemNestedFragment
    children {
      ...WaiverFormTemplateItemNestedFragment
    }
  }
}
    ${WaiverFormTemplateItemNestedFragmentFragmentDoc}`;
export const WaiverFormDetailFragmentFragmentDoc = gql`
    fragment WaiverFormDetailFragment on WaiverForm {
  uuid
  group_uuid
  waiver_template_uuid
  name
  live_start_date
  live_end_date
  status
  last_interaction_by_name
  last_interaction_time
  template {
    uuid
    label
    period
    status
    category {
      uuid
      name
    }
    items {
      ...WaiverFormTemplateItemFragment
    }
  }
  currentTemplate {
    uuid
    label
    period
    status
    category {
      uuid
      name
    }
    items {
      ...WaiverFormTemplateItemFragment
    }
  }
  fields {
    uuid
    value
    format
    waiver_template_item_field_uuid
    templateItemField {
      ...WaiverFormItemFieldFragment
    }
  }
}
    ${WaiverFormTemplateItemFragmentFragmentDoc}
${WaiverFormItemFieldFragmentFragmentDoc}`;
export const WaiverFormSubmissionFragmentFragmentDoc = gql`
    fragment WaiverFormSubmissionFragment on WaiverFormSubmission {
  uuid
  submitted_at
  is_test
  student_id
  first_name
  last_name
  email
  form {
    uuid
    group_uuid
    name
    template {
      uuid
      label
      category {
        uuid
        name
      }
    }
  }
}
    `;
export const WaiverTemplateItemNestedFragmentFragmentDoc = gql`
    fragment WaiverTemplateItemNestedFragment on WaiverTemplateItem {
  uuid
  waiver_template_uuid
  parent_item_uuid
  type
  position
  payload
  waiver_question_uuid
  question_required
  waiver_content_uuid
  question {
    ...WaiverQuestionFragment
  }
  content {
    ...WaiverContentFragment
  }
}
    ${WaiverQuestionFragmentFragmentDoc}
${WaiverContentFragmentFragmentDoc}`;
export const WaiverTemplateItemFragmentFragmentDoc = gql`
    fragment WaiverTemplateItemFragment on WaiverTemplateItem {
  ...WaiverTemplateItemNestedFragment
  children {
    ...WaiverTemplateItemNestedFragment
    children {
      ...WaiverTemplateItemNestedFragment
    }
  }
}
    ${WaiverTemplateItemNestedFragmentFragmentDoc}`;
export const WaiverTemplateFragmentFragmentDoc = gql`
    fragment WaiverTemplateFragment on WaiverTemplate {
  uuid
  group_uuid
  waiver_category_uuid
  label
  period
  type
  status
  category {
    uuid
    name
  }
  items {
    ...WaiverTemplateItemFragment
  }
  creation_time
  created_by_name
  last_update_time
  last_interaction_time
  last_interaction_by_name
}
    ${WaiverTemplateItemFragmentFragmentDoc}`;
export const MessageResponseFragmentFragmentDoc = gql`
    fragment MessageResponseFragment on MessageResponse {
  message
  type
}
    `;
export const PaginationFragmentFragmentDoc = gql`
    fragment PaginationFragment on PaginatorInfo {
  total
  perPage
  currentPage
  hasMorePages
}
    `;
export const ColorRgbFragmentFragmentDoc = gql`
    fragment ColorRGBFragment on ColorRGB {
  r
  g
  b
}
    `;
export const PartnerColorsFragmentFragmentDoc = gql`
    fragment PartnerColorsFragment on PartnerColors {
  bg {
    ...ColorRGBFragment
  }
  text {
    ...ColorRGBFragment
  }
  menuFocus {
    ...ColorRGBFragment
  }
  menuSelectedBg {
    ...ColorRGBFragment
  }
  menuSelectedText {
    ...ColorRGBFragment
  }
  menuText {
    ...ColorRGBFragment
  }
  menuHover {
    ...ColorRGBFragment
  }
  menuHoverText {
    ...ColorRGBFragment
  }
  logoOneColor
  logoColor {
    ...ColorRGBFragment
  }
}
    ${ColorRgbFragmentFragmentDoc}`;
export const RefCodeTermFragmentFragmentDoc = gql`
    fragment RefCodeTermFragment on RefCodeTerm {
  id
  uuid
  ref_code_id
  term_name
  term_start
  term_end
  offer_open_date
}
    `;
export const TuitionImplementationFragmentFragmentDoc = gql`
    fragment TuitionImplementationFragment on TuitionImplementation {
  id
  season
  term
  effective_date
  payment_gateway
  ref_code_id
}
    `;
export const SchoolFragmentFragmentDoc = gql`
    fragment SchoolFragment on School {
  id
  school_name
  address1
  address2
  address_city
  address_state
  address_zip
  address_country
  logo_url
  website_url
  erp_code
  renters_contract_id
  tuition_contract_id
  hasRentersCoverageConfirmationPro
  hasRentersCoverageConfirmationLite
  primaryRefCode {
    id
    lastTerm {
      ...RefCodeTermFragment
    }
    currentRentersImplementation {
      id
      effective_date
      start_date
      default_property_coverage
      default_liability_coverage
    }
    currentTuitionImplementation {
      ...TuitionImplementationFragment
    }
  }
}
    ${RefCodeTermFragmentFragmentDoc}
${TuitionImplementationFragmentFragmentDoc}`;
export const PartnerSessionFragmentFragmentDoc = gql`
    fragment PartnerSessionFragment on Partner {
  id
  uuid
  name
  school_id
  liability_waiver
  colors {
    ...PartnerColorsFragment
  }
  sessionRights {
    id
    code
  }
  refCodes {
    id
    code
  }
  school {
    ...SchoolFragment
  }
  sessionStatus
}
    ${PartnerColorsFragmentFragmentDoc}
${SchoolFragmentFragmentDoc}`;
export const PartnerPortalContactSessionFragmentFragmentDoc = gql`
    fragment PartnerPortalContactSessionFragment on PartnerPortalContact {
  id
  partner_id
  contact_status
  partner {
    ...PartnerSessionFragment
  }
}
    ${PartnerSessionFragmentFragmentDoc}`;
export const PortalContactSessionFragmentFragmentDoc = gql`
    fragment PortalContactSessionFragment on PortalContact {
  id
  partner_id_default
  first_name
  last_name
  preferred_name
  email
  pronouns
  sms_phone
  requiresMfa
  portal_contact_status
  locked
  uuid
  terms_and_conditions_acknowledgment_dt
  partnerPortalContactsActive {
    ...PartnerPortalContactSessionFragment
  }
  sessionImpersonation
}
    ${PartnerPortalContactSessionFragmentFragmentDoc}`;
export const AgentFragmentFragmentDoc = gql`
    fragment AgentFragment on Agent {
  id
  first_name
  last_name
  email
  full_name
}
    `;
export const PortalContactFragmentFragmentDoc = gql`
    fragment PortalContactFragment on PortalContact {
  id
  partner_id_default
  first_name
  last_name
  preferred_name
  email
  pronouns
  sms_phone
  requiresMfa
  portal_contact_status
  locked
  uuid
}
    `;
export const PartnerPortalContactFragmentFragmentDoc = gql`
    fragment PartnerPortalContactFragment on PartnerPortalContact {
  partner_id
  portal_contact_id
  contact_status
}
    `;
export const PortalContactTableFragmentFragmentDoc = gql`
    fragment PortalContactTableFragment on PortalContact {
  ...PortalContactFragment
  partnerPortalContact(partner_id: $partner_id) {
    ...PartnerPortalContactFragment
  }
}
    ${PortalContactFragmentFragmentDoc}
${PartnerPortalContactFragmentFragmentDoc}`;
export const PartnerRoleFragmentFragmentDoc = gql`
    fragment PartnerRoleFragment on PartnerRole {
  id
  code
  name
  description
}
    `;
export const RefundPolicyFragmentFragmentDoc = gql`
    fragment RefundPolicyFragment on RefundPolicy {
  id
  uuid
  tuition_implementation_id
  renters_implementation_id
  refund_policy_content
  refund_policy_status
  creation_time
  last_update_time
  last_update_by
  last_update_by_type
  created_by
  created_by_type
  last_update_reason
  record_status
}
    `;
export const RentersImplementationFragmentFragmentDoc = gql`
    fragment RentersImplementationFragment on RentersImplementation {
  id
  start_date
  min_property_coverage
  min_liability_coverage
}
    `;
export const SnowFlakeRentersDecisionsFragmentFragmentDoc = gql`
    fragment SnowFlakeRentersDecisionsFragment on SnowFlakeRentersDecisions {
  purchase
  billmelater
  renewal
  remindmelater
  none
  decline
}
    `;
export const SnowFlakeRentersMonthlyDecisionsPurchaseFragmentFragmentDoc = gql`
    fragment SnowFlakeRentersMonthlyDecisionsPurchaseFragment on SnowFlakeRentersMonthlyDecisionsPurchase {
  id
  month
  year
  total
  purchased
}
    `;
export const SnowFlakePolicyRentersTrendsFragmentFragmentDoc = gql`
    fragment SnowFlakePolicyRentersTrendsFragment on SnowFlakePolicyRentersTrends {
  PROPERTY
  EARTHQUAKE
  LIABILITY
  DEDUCTIBLE
  TOTAL
  POLICIES
}
    `;
export const SnowFlakePolicyCoveredFragmentFragmentDoc = gql`
    fragment SnowFlakePolicyCoveredFragment on SnowFlakePolicyCovered {
  activeInRange
  range_status_active
  range_status_pending
  range_status_other
  range_purchases
  total
  school_id
  schoolCapacity
}
    `;
export const UpdateByUserFragmentFragmentDoc = gql`
    fragment UpdateByUserFragment on UpdateByUser {
  id
  first_name
  last_name
}
    `;
export const SnowflakeRentersPolicyFragmentFragmentDoc = gql`
    fragment SnowflakeRentersPolicyFragment on SnowflakeRentersPolicy {
  POLICY_ID
  INSURANCE_CARRIER
  INSURANCE_TYPE
  FILE_ID
  FILE_EXT
  ON_CAMPUS
  IS_AUTO_RENEW
  POLICY_NUMBER
  POLICY_STATUS
  POLICY_STATUS_TODAY
  SCHOOL_ID
  SCHOOL_NAME
  REF_CODE
  RENTERS_IMPLEMENTATION_ID
  STUDENT_NAME
  STUDENT_FIRST_NAME
  STUDENT_LAST_NAME
  STUDENT_EMAIL
  STUDENT_PHONE
  STUDENT_EXTERNAL_ID
  PURCHASE_BY
  PRIMARY_INSURED_ADDRESS
  PRIMARY_INSURED_CITY
  PRIMARY_INSURED_STATE
  PRIMARY_INSURED_ZIP
  IS_FLAT_CANCEL
  COVERAGE_START_DATE
  COVERAGE_END_DATE
  COVERAGE_END_DATE_OR_AUTO_RENEW
  CANCELLATION_DATE
  CANCELLATION_REASON
  CANCELLATION_SOURCE
  CONFIRMATION_NOTE
  PAYMENT_INTERVAL
  DEDUCTIBLE
  PROPERTY_COVERAGE
  LIABILITY_COVERAGE
  EARTHQUAKE_COVERAGE
  POLICY_CREATION_TIME
  ENROLLMENT_DATE
  POLICY_SOURCE
  CREATED_BY
  CREATED_BY_TYPE
  LAST_UPDATE_BY
  LAST_UPDATE_TIME
  LAST_UPDATE_BY_TYPE
  rangeStatus(end_date: $end_date)
  lastUpdateBy {
    ...UpdateByUserFragment
  }
}
    ${UpdateByUserFragmentFragmentDoc}`;
export const RefundPolicyFlowFragmentFragmentDoc = gql`
    fragment RefundPolicyFlowFragment on RefundPolicyFlow {
  date
  description
  refund_policy_id
  uuid
}
    `;
export const SnowFlakeRefundAcknowledgmentVuFragmentFragmentDoc = gql`
    fragment SnowFlakeRefundAcknowledgmentVuFragment on SnowFlakeRefundAcknowledgmentVu {
  QUICK_USER_ID
  STUDENT_ID
  STUDENT_NAME
  STUDENT_FIRST_NAME
  STUDENT_LAST_NAME
  STUDENT_EMAIL
  WHO_HAS_ACKNOWLEDGED
  MOST_RECENT_ACKNOWLEDGEMENT_TIME
  MOST_RECENT_REFUND_POLICY_CONTENT
  QU_POLICY_NUMBER
  POLICY_NUMBER
  ENROLLMENT_DATE
  combinedRefundPolicyFlow {
    ...RefundPolicyFlowFragment
  }
}
    ${RefundPolicyFlowFragmentFragmentDoc}`;
export const SnowFlakeTuitionDecisionsFragmentFragmentDoc = gql`
    fragment SnowFlakeTuitionDecisionsFragment on SnowFlakeTuitionDecisions {
  purchase
  accept
  remindmelater
  decline
}
    `;
export const SnowFlakeTuitionMonthlyDecisionsPurchaseFragmentFragmentDoc = gql`
    fragment SnowFlakeTuitionMonthlyDecisionsPurchaseFragment on SnowFlakeTuitionMonthlyDecisionsPurchase {
  id
  month
  year
  total
  purchased
}
    `;
export const SnowFlakePolicyTuitionTrendsFragmentFragmentDoc = gql`
    fragment SnowFlakePolicyTuitionTrendsFragment on SnowFlakePolicyTuitionTrends {
  TOTAL
  AVERAGE
  POLICIES
}
    `;
export const SnowFlakeTuitionPolicyCoveredFragmentFragmentDoc = gql`
    fragment SnowFlakeTuitionPolicyCoveredFragment on SnowFlakeTuitionPolicyCovered {
  activeInRange
  range_status_active
  range_status_pending
  range_status_other
  range_purchases
  total
  school_id
  schoolCapacity
}
    `;
export const SnowflakeTuitionPolicyFragmentFragmentDoc = gql`
    fragment SnowflakeTuitionPolicyFragment on SnowflakeTuitionPolicy {
  POLICY_NUMBER
  POLICY_ID
  POLICY_CREATION_TIME
  ENROLLMENT_DATE
  POLICY_SOURCE
  START_DATE
  END_DATE
  DAYS_COVERED
  POLICY_STATUS
  SCHOOL_NAME
  SCHOOL_ID
  REF_CODE
  TUITION_IMPLEMENTATION_ID
  PAYMENT_GATEWAY
  PROGRAM_TYPE
  PRICE
  IS_PAID
  AMOUNT_PAID
  IS_REFUNDED
  AMOUNT_REFUNDED
  REFUND_MORE_THAN_PRICE
  NUM_REFUNDS
  PAYMENT_STATUS
  CHARGE_DATE
  REFUND_TIME
  COVERAGE_AMOUNT
  YEARLY_GOAL_ASSIGNED_TO
  TERM_GOAL_ASSIGNED_TO
  MEMBERSHIP_ID
  ENTITY_ID
  INSURED_NAME
  INSURED_FIRST_NAME
  INSURED_LAST_NAME
  INSURED_PHONE
  INSURED_EMAIL
  INSURED_ADDRESS
  INSURED_CITY
  INSURED_STATE
  INSURED_ZIP
  IS_ON_CAMPUS
  ACCOUNT_OWNER_NAME
  ACCOUNT_OWNER_PHONE
  ACCOUNT_HOLDER_EMAIL
  IS_PURCHASED_BY_STUDENT
  TERM_AND_SEASON
  CALENDAR_TERM
  IMPLEMENTATION_TERM
  IMPLEMENTATION_SEASON
  OFFER_OPEN_DATE
  DAYS_SINCE_OFFER_OPEN
  DAYS_SINCE_BILL_DATE
  DAYS_SINCE_BILL_DATE_DUE
  DAYS_BEFORE_TERM_START
  CANCELLATION_DATE
  CANCELLATION_REASON
  CANCELLATION_SOURCE
  IS_FLAT_CANCEL
  PAYMENT_TRANSACTION_ID
  INSURED_EXTERNAL_ID
  rangeStatus(end_date: $end_date)
}
    `;
export const ZdTicketFragmentFragmentDoc = gql`
    fragment ZDTicketFragment on ZDTicket {
  url
  id
  created_at
  updated_at
  type
  subject
  raw_subject
  description
  status
  recipient
  requester_id
  submitter_id
  assignee_id
  organization_id
  group_id
  has_incidents
  is_public
  due_at
  ticket_form_id
  brand_id
  allow_channelback
  allow_attachments
  from_messaging_channel
}
    `;
export const ZdTicketCommentFragmentFragmentDoc = gql`
    fragment ZDTicketCommentFragment on ZDTicketComment {
  id
  author_id
  public
  audit_id
  body
  html_body
  plain_body
  created_at
}
    `;
export const ZdUserFragmentFragmentDoc = gql`
    fragment ZDUserFragment on ZDUser {
  id
  name
  email
  created_at
}
    `;
export const PortalContactsSelectDocument = gql`
    query portalContactsSelect($first: Int, $search: PortalContactsInput!) {
  portalContacts(first: $first, search: $search) {
    data {
      ...PortalContactSelectFragment
    }
  }
}
    ${PortalContactSelectFragmentFragmentDoc}`;
export const WaiverCategoriesDocument = gql`
    query waiverCategories($first: Int, $page: Int, $partner_id: Int!, $showAllByAdmin: Boolean, $inputGenerated: WaiverCategorySearchInputGenerated, $orderBy: [OrderByClause!]) {
  waiverCategories(
    first: $first
    page: $page
    partner_id: $partner_id
    showAllByAdmin: $showAllByAdmin
    inputGenerated: $inputGenerated
    orderBy: $orderBy
  ) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...WaiverCategoryFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${WaiverCategoryFragmentFragmentDoc}`;
export const WaiverCategoryUsersDocument = gql`
    query waiverCategoryUsers($first: Int, $page: Int, $partner_id: Int!, $search: PortalContactsInput!, $orderBy: [OrderByClause!]) {
  waiverCategoryUsers(
    first: $first
    page: $page
    search: $search
    orderBy: $orderBy
  ) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...WaiverCategoryUserFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${WaiverCategoryUserFragmentFragmentDoc}`;
export const WaiverContentsDocument = gql`
    query waiverContents($first: Int, $page: Int, $partner_id: Int!, $inputGenerated: WaiverContentSearchInputGenerated, $orderBy: [OrderByClause!], $orderByCategoryName: SortOrder) {
  waiverContents(
    first: $first
    page: $page
    partner_id: $partner_id
    inputGenerated: $inputGenerated
    orderBy: $orderBy
    orderByCategoryName: $orderByCategoryName
  ) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...WaiverContentFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${WaiverContentFragmentFragmentDoc}`;
export const WaiverFormDocument = gql`
    query waiverForm($groupUuid: String!, $partner_id: Int!) {
  waiverForm(groupUuid: $groupUuid, partner_id: $partner_id) {
    ...WaiverFormDetailFragment
  }
}
    ${WaiverFormDetailFragmentFragmentDoc}`;
export const WaiverFormsDocument = gql`
    query waiverForms($first: Int, $page: Int, $partner_id: Int!, $inputGenerated: WaiverFormSearchInputGenerated, $orderBy: [OrderByClause!], $orderByTemplateLabel: SortOrder, $orderByCategoryName: SortOrder) {
  waiverForms(
    first: $first
    page: $page
    partner_id: $partner_id
    inputGenerated: $inputGenerated
    orderBy: $orderBy
    orderByTemplateLabel: $orderByTemplateLabel
    orderByCategoryName: $orderByCategoryName
  ) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...WaiverFormFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${WaiverFormFragmentFragmentDoc}`;
export const WaiverListsDocument = gql`
    query waiverLists($first: Int, $page: Int, $partner_id: Int!, $inputGenerated: WaiverListSearchInputGenerated, $orderBy: [OrderByClause!]) {
  waiverLists(
    first: $first
    page: $page
    partner_id: $partner_id
    inputGenerated: $inputGenerated
    orderBy: $orderBy
  ) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...WaiverListFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${WaiverListFragmentFragmentDoc}`;
export const WaiverQuestionsDocument = gql`
    query waiverQuestions($first: Int, $page: Int, $partner_id: Int!, $inputGenerated: WaiverQuestionSearchInputGenerated, $orderBy: [OrderByClause!], $orderByCategoryName: SortOrder) {
  waiverQuestions(
    first: $first
    page: $page
    partner_id: $partner_id
    inputGenerated: $inputGenerated
    orderBy: $orderBy
    orderByCategoryName: $orderByCategoryName
  ) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...WaiverQuestionFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${WaiverQuestionFragmentFragmentDoc}`;
export const WaiverFormSubmissionsDocument = gql`
    query waiverFormSubmissions($first: Int, $page: Int, $partner_id: Int!, $inputGenerated: WaiverFormSubmissionSearchInputGenerated, $orderBy: [OrderByClause!], $orderByFirstName: SortOrder, $orderByLastName: SortOrder, $orderByFormName: SortOrder, $orderByTemplateLabel: SortOrder, $orderByCategoryName: SortOrder) {
  waiverFormSubmissions(
    first: $first
    page: $page
    partner_id: $partner_id
    inputGenerated: $inputGenerated
    orderBy: $orderBy
    orderByFirstName: $orderByFirstName
    orderByLastName: $orderByLastName
    orderByFormName: $orderByFormName
    orderByTemplateLabel: $orderByTemplateLabel
    orderByCategoryName: $orderByCategoryName
  ) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...WaiverFormSubmissionFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${WaiverFormSubmissionFragmentFragmentDoc}`;
export const WaiverTemplatesDocument = gql`
    query waiverTemplates($first: Int, $page: Int, $partner_id: Int!, $inputGenerated: WaiverTemplateSearchInputGenerated, $orderBy: [OrderByClause!], $orderByCategoryName: SortOrder) {
  waiverTemplates(
    first: $first
    page: $page
    partner_id: $partner_id
    inputGenerated: $inputGenerated
    orderBy: $orderBy
    orderByCategoryName: $orderByCategoryName
  ) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...WaiverTemplateFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${WaiverTemplateFragmentFragmentDoc}`;
export const WaiverTemplateDocument = gql`
    query waiverTemplate($groupUuid: String!, $partner_id: Int!) {
  waiverTemplate(groupUuid: $groupUuid, partner_id: $partner_id) {
    ...WaiverTemplateFragment
  }
}
    ${WaiverTemplateFragmentFragmentDoc}`;
export const SalesRepresentativeDocument = gql`
    query salesRepresentative($school_id: Int!) {
  salesRepresentative(school_id: $school_id) {
    ...AgentFragment
  }
}
    ${AgentFragmentFragmentDoc}`;
export const RentersAccountManagerDocument = gql`
    query rentersAccountManager($partner_id: Int!) {
  rentersAccountManager(partner_id: $partner_id) {
    ...AgentFragment
  }
}
    ${AgentFragmentFragmentDoc}`;
export const TuitionAccountManagerDocument = gql`
    query tuitionAccountManager($partner_id: Int!) {
  tuitionAccountManager(partner_id: $partner_id) {
    ...AgentFragment
  }
}
    ${AgentFragmentFragmentDoc}`;
export const PortalContactCreateDocument = gql`
    mutation portalContactCreate($partner_id: Int!, $input: PortalContactCreateInput!) {
  portalContactCreate(partner_id: $partner_id, input: $input) {
    message
    type
    data {
      ...PortalContactFragment
    }
  }
}
    ${PortalContactFragmentFragmentDoc}`;
export const PortalContactUpdateDocument = gql`
    mutation portalContactUpdate($id: Int!, $input: PortalContactUpdateInput!) {
  portalContactUpdate(id: $id, input: $input) {
    ...PortalContactFragment
  }
}
    ${PortalContactFragmentFragmentDoc}`;
export const PortalContactSendWelcomeEmailDocument = gql`
    mutation portalContactSendWelcomeEmail($id: Int!) {
  portalContactSendWelcomeEmail(id: $id) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const PortalContactRequestResetPassDocument = gql`
    mutation portalContactRequestResetPass($id: Int!) {
  portalContactRequestResetPass(id: $id) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const PortalContactsDocument = gql`
    query portalContacts($first: Int, $page: Int, $orderBy: [OrderByClause!], $search: PortalContactsInput!, $partner_id: Int!) {
  portalContacts(first: $first, page: $page, orderBy: $orderBy, search: $search) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...PortalContactTableFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${PortalContactTableFragmentFragmentDoc}`;
export const PortalContactDocument = gql`
    query portalContact($search: PortalContactInput!, $partner_id: Int!) {
  portalContact(search: $search, partner_id: $partner_id) {
    ...PortalContactTableFragment
  }
}
    ${PortalContactTableFragmentFragmentDoc}`;
export const PortalContactStatusUpdateDocument = gql`
    mutation portalContactStatusUpdate($id: Int!, $partner_id: Int!, $contact_status: PortalContactStatus!) {
  portalContactStatusUpdate(
    id: $id
    partner_id: $partner_id
    contact_status: $contact_status
  ) {
    message
    type
    data {
      ...PortalContactTableFragment
    }
  }
}
    ${PortalContactTableFragmentFragmentDoc}`;
export const PortalContactUnlockDocument = gql`
    mutation portalContactUnlock($id: Int!) {
  portalContactUnlock(id: $id) {
    ...PortalContactFragment
  }
}
    ${PortalContactFragmentFragmentDoc}`;
export const PartnerContactRolesUpdateDocument = gql`
    mutation partnerContactRolesUpdate($contactId: Int!, $partnerId: Int!, $create: [Int!], $delete: [Int!]) {
  partnerContactRolesUpdate(
    contactId: $contactId
    partnerId: $partnerId
    create: $create
    delete: $delete
  ) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const PartnerRolesDocument = gql`
    query partnerRoles($first: Int, $page: Int, $orderBy: [OrderByClause!], $search: PartnerRolesSearchInput!) {
  partnerRoles(first: $first, page: $page, orderBy: $orderBy, search: $search) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...PartnerRoleFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${PartnerRoleFragmentFragmentDoc}`;
export const PartnerContactRolesDocument = gql`
    query partnerContactRoles($partner_id: Int!, $contact_id: Int!) {
  partnerContactRoles(partner_id: $partner_id, contact_id: $contact_id) {
    ...PartnerRoleFragment
  }
}
    ${PartnerRoleFragmentFragmentDoc}`;
export const PortalContactAcceptTermsConditionsDocument = gql`
    mutation portalContactAcceptTermsConditions {
  portalContactAcceptTermsConditions {
    ...PortalContactSessionFragment
  }
}
    ${PortalContactSessionFragmentFragmentDoc}`;
export const PortalContactLoggedDocument = gql`
    query portalContactLogged {
  portalContactLogged {
    ...PortalContactSessionFragment
  }
}
    ${PortalContactSessionFragmentFragmentDoc}`;
export const PortalContactSessionPasswordUpdateDocument = gql`
    mutation portalContactSessionPasswordUpdate($input: PortalContactSessionPasswordUpdateInput!) {
  portalContactSessionPasswordUpdate(input: $input) {
    ...PortalContactSessionFragment
  }
}
    ${PortalContactSessionFragmentFragmentDoc}`;
export const PortalContactSessionEmailPhoneUpdateDocument = gql`
    mutation portalContactSessionEmailPhoneUpdate($input: PortalContactSessionEmailPhoneUpdateInput!) {
  portalContactSessionEmailPhoneUpdate(input: $input) {
    ...PortalContactSessionFragment
  }
}
    ${PortalContactSessionFragmentFragmentDoc}`;
export const PortalContactSessionUpdateDocument = gql`
    mutation portalContactSessionUpdate($input: PortalContactSessionUpdateInput!) {
  portalContactSessionUpdate(input: $input) {
    ...PortalContactSessionFragment
  }
}
    ${PortalContactSessionFragmentFragmentDoc}`;
export const RefundPoliciesDocument = gql`
    query refundPolicies($input: RefundPoliciesInput!) {
  refundPolicies(input: $input) {
    ...RefundPolicyFragment
  }
}
    ${RefundPolicyFragmentFragmentDoc}`;
export const RentersImplementationDocument = gql`
    query rentersImplementation($id: Int!) {
  rentersImplementation(id: $id) {
    ...RentersImplementationFragment
  }
}
    ${RentersImplementationFragmentFragmentDoc}`;
export const RentersCoverageConfirmationSaveDocument = gql`
    mutation rentersCoverageConfirmationSave($uuid: String!, $partnerId: Int!, $input: RentersCoverageConfirmationSaveInput!, $end_date: String!) {
  rentersCoverageConfirmationSave(
    uuid: $uuid
    partnerId: $partnerId
    input: $input
  ) {
    ...SnowflakeRentersPolicyFragment
  }
}
    ${SnowflakeRentersPolicyFragmentFragmentDoc}`;
export const RentersCoverageConfirmationApproveDocument = gql`
    mutation rentersCoverageConfirmationApprove($uuid: String!, $partnerId: Int!, $input: RentersCoverageConfirmationApproveInput!, $end_date: String!) {
  rentersCoverageConfirmationApprove(
    uuid: $uuid
    partnerId: $partnerId
    input: $input
  ) {
    ...SnowflakeRentersPolicyFragment
  }
}
    ${SnowflakeRentersPolicyFragmentFragmentDoc}`;
export const RentersCoverageConfirmationRejectDocument = gql`
    mutation rentersCoverageConfirmationReject($uuid: String!, $partnerId: Int!, $reason: String, $end_date: String!) {
  rentersCoverageConfirmationReject(
    uuid: $uuid
    partnerId: $partnerId
    reason: $reason
  ) {
    ...SnowflakeRentersPolicyFragment
  }
}
    ${SnowflakeRentersPolicyFragmentFragmentDoc}`;
export const RentersCoverageConfirmationAsPendingDocument = gql`
    mutation rentersCoverageConfirmationAsPending($uuid: String!, $partnerId: Int!, $end_date: String!) {
  rentersCoverageConfirmationAsPending(uuid: $uuid, partnerId: $partnerId) {
    ...SnowflakeRentersPolicyFragment
  }
}
    ${SnowflakeRentersPolicyFragmentFragmentDoc}`;
export const SnowflakeRentersDecisionsDocument = gql`
    query snowflakeRentersDecisions($input: SnowFlakeRentersDecisionsInput!) {
  snowflakeRentersDecisions(input: $input) {
    ...SnowFlakeRentersDecisionsFragment
  }
}
    ${SnowFlakeRentersDecisionsFragmentFragmentDoc}`;
export const SnowflakeRentersMonthlyDecisionsPurchaseDocument = gql`
    query snowflakeRentersMonthlyDecisionsPurchase($input: SnowFlakeRentersDecisionsInput!) {
  snowflakeRentersMonthlyDecisionsPurchase(input: $input) {
    ...SnowFlakeRentersMonthlyDecisionsPurchaseFragment
  }
}
    ${SnowFlakeRentersMonthlyDecisionsPurchaseFragmentFragmentDoc}`;
export const SnowflakeRentersPoliciesDocument = gql`
    query snowflakeRentersPolicies($first: Int, $page: Int, $orderBy: [OrderByClause!], $input: SnowflakeRentersPolicyInput!, $end_date: String!) {
  snowflakeRentersPolicies(
    first: $first
    page: $page
    orderBy: $orderBy
    input: $input
  ) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...SnowflakeRentersPolicyFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${SnowflakeRentersPolicyFragmentFragmentDoc}`;
export const SnowflakeRentersPolicyDocument = gql`
    query snowflakeRentersPolicy($input: SnowFlakeRentersPolicyInput!, $end_date: String!) {
  snowflakeRentersPolicy(input: $input) {
    ...SnowflakeRentersPolicyFragment
  }
}
    ${SnowflakeRentersPolicyFragmentFragmentDoc}`;
export const SnowflakePolicyRentersTrendsDocument = gql`
    query snowflakePolicyRentersTrends($input: SnowFlakePolicyStatsInput!) {
  snowflakePolicyRentersTrends(input: $input) {
    ...SnowFlakePolicyRentersTrendsFragment
  }
}
    ${SnowFlakePolicyRentersTrendsFragmentFragmentDoc}`;
export const SnowflakePolicyRentersCoveredDocument = gql`
    query snowflakePolicyRentersCovered($input: SnowFlakePolicyStatsInput!) {
  snowflakePolicyRentersCovered(input: $input) {
    ...SnowFlakePolicyCoveredFragment
  }
}
    ${SnowFlakePolicyCoveredFragmentFragmentDoc}`;
export const SnowflakeRefundAcknowledgmentVuSearchDocument = gql`
    query snowflakeRefundAcknowledgmentVuSearch($input: SnowFlakeRefundAcknowledgementVuSearchInput!, $orderBy: [OrderByClause!], $first: Int, $page: Int) {
  snowflakeRefundAcknowledgmentVuSearch(
    input: $input
    orderBy: $orderBy
    first: $first
    page: $page
  ) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...SnowFlakeRefundAcknowledgmentVuFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${SnowFlakeRefundAcknowledgmentVuFragmentFragmentDoc}`;
export const SnowflakeTuitionDecisionsDocument = gql`
    query snowflakeTuitionDecisions($input: SnowFlakeTuitionDecisionsInput!) {
  snowflakeTuitionDecisions(input: $input) {
    ...SnowFlakeTuitionDecisionsFragment
  }
}
    ${SnowFlakeTuitionDecisionsFragmentFragmentDoc}`;
export const SnowflakeTuitionMonthlyDecisionsPurchaseDocument = gql`
    query snowflakeTuitionMonthlyDecisionsPurchase($input: SnowFlakeTuitionDecisionsInput!) {
  snowflakeTuitionMonthlyDecisionsPurchase(input: $input) {
    ...SnowFlakeTuitionMonthlyDecisionsPurchaseFragment
  }
}
    ${SnowFlakeTuitionMonthlyDecisionsPurchaseFragmentFragmentDoc}`;
export const SnowflakeTuitionPoliciesDocument = gql`
    query snowflakeTuitionPolicies($first: Int, $page: Int, $orderBy: [OrderByClause!], $input: SnowflakeTuitionPolicyInput!, $end_date: String!) {
  snowflakeTuitionPolicies(
    first: $first
    page: $page
    orderBy: $orderBy
    input: $input
  ) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...SnowflakeTuitionPolicyFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${SnowflakeTuitionPolicyFragmentFragmentDoc}`;
export const SnowflakeTuitionPolicyDocument = gql`
    query snowflakeTuitionPolicy($input: SnowFlakeTuitionPolicyInput!, $end_date: String!) {
  snowflakeTuitionPolicy(input: $input) {
    ...SnowflakeTuitionPolicyFragment
  }
}
    ${SnowflakeTuitionPolicyFragmentFragmentDoc}`;
export const SnowflakePolicyTuitionTrendsDocument = gql`
    query snowflakePolicyTuitionTrends($input: SnowFlakeTuitionPolicyStatsInput!) {
  snowflakePolicyTuitionTrends(input: $input) {
    ...SnowFlakePolicyTuitionTrendsFragment
  }
}
    ${SnowFlakePolicyTuitionTrendsFragmentFragmentDoc}`;
export const SnowflakePolicyTuitionCoveredDocument = gql`
    query snowflakePolicyTuitionCovered($input: SnowFlakeTuitionPolicyStatsInput!) {
  snowflakePolicyTuitionCovered(input: $input) {
    ...SnowFlakeTuitionPolicyCoveredFragment
  }
}
    ${SnowFlakeTuitionPolicyCoveredFragmentFragmentDoc}`;
export const TermsDocument = gql`
    query terms($first: Int, $page: Int, $orderBy: [OrderByClause!], $input: TermsInput!) {
  terms(first: $first, page: $page, orderBy: $orderBy, input: $input) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...RefCodeTermFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${RefCodeTermFragmentFragmentDoc}`;
export const TuitionImplementationsDocument = gql`
    query tuitionImplementations($first: Int, $page: Int, $orderBy: [OrderByClause!], $input: TuitionImplementationInput!) {
  tuitionImplementations(
    first: $first
    page: $page
    orderBy: $orderBy
    input: $input
  ) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...TuitionImplementationFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${TuitionImplementationFragmentFragmentDoc}`;
export const WaiverCategoryCreateDocument = gql`
    mutation waiverCategoryCreate($partner_id: Int!, $input: WaiverCategoryInput!) {
  waiverCategoryCreate(partner_id: $partner_id, input: $input) {
    ...WaiverCategoryFragment
  }
}
    ${WaiverCategoryFragmentFragmentDoc}`;
export const WaiverCategoryUpdateDocument = gql`
    mutation waiverCategoryUpdate($uuid: String!, $partner_id: Int!, $input: WaiverCategoryInput!) {
  waiverCategoryUpdate(uuid: $uuid, partner_id: $partner_id, input: $input) {
    ...WaiverCategoryFragment
  }
}
    ${WaiverCategoryFragmentFragmentDoc}`;
export const WaiverCategoryStatusUpdateDocument = gql`
    mutation waiverCategoryStatusUpdate($uuid: String!, $partner_id: Int!, $status: WaiverCategoryStatus!) {
  waiverCategoryStatusUpdate(
    uuid: $uuid
    partner_id: $partner_id
    status: $status
  ) {
    ...WaiverCategoryFragment
  }
}
    ${WaiverCategoryFragmentFragmentDoc}`;
export const WaiverCategoryContactsUpdateDocument = gql`
    mutation waiverCategoryContactsUpdate($uuid: String!, $partner_id: Int!, $portal_contact_ids: [Int!]!) {
  waiverCategoryContactsUpdate(
    uuid: $uuid
    partner_id: $partner_id
    portal_contact_ids: $portal_contact_ids
  ) {
    ...WaiverCategoryFragment
  }
}
    ${WaiverCategoryFragmentFragmentDoc}`;
export const WaiverCategoryUserUpdateDocument = gql`
    mutation waiverCategoryUserUpdate($portal_contact_id: Int!, $partner_id: Int!, $waiver_category_uuids: [String!]!) {
  waiverCategoryUserUpdate(
    portal_contact_id: $portal_contact_id
    partner_id: $partner_id
    waiver_category_uuids: $waiver_category_uuids
  ) {
    ...WaiverCategoryUserFragment
  }
}
    ${WaiverCategoryUserFragmentFragmentDoc}`;
export const WaiverContentCreateDocument = gql`
    mutation waiverContentCreate($partner_id: Int!, $input: WaiverContentInput!) {
  waiverContentCreate(partner_id: $partner_id, input: $input) {
    ...WaiverContentFragment
  }
}
    ${WaiverContentFragmentFragmentDoc}`;
export const WaiverContentUpdateDocument = gql`
    mutation waiverContentUpdate($group_uuid: String!, $partner_id: Int!, $input: WaiverContentInput!) {
  waiverContentUpdate(
    group_uuid: $group_uuid
    partner_id: $partner_id
    input: $input
  ) {
    ...WaiverContentFragment
  }
}
    ${WaiverContentFragmentFragmentDoc}`;
export const WaiverContentStatusUpdateDocument = gql`
    mutation waiverContentStatusUpdate($group_uuid: String!, $partner_id: Int!, $status: WaiverContentStatus!) {
  waiverContentStatusUpdate(
    group_uuid: $group_uuid
    partner_id: $partner_id
    status: $status
  ) {
    ...WaiverContentFragment
  }
}
    ${WaiverContentFragmentFragmentDoc}`;
export const WaiverFormCreateDocument = gql`
    mutation waiverFormCreate($partner_id: Int!, $input: WaiverFormInput!) {
  waiverFormCreate(partner_id: $partner_id, input: $input) {
    ...WaiverFormDetailFragment
  }
}
    ${WaiverFormDetailFragmentFragmentDoc}`;
export const WaiverFormUpdateDocument = gql`
    mutation waiverFormUpdate($group_uuid: String!, $partner_id: Int!, $input: WaiverFormInput!, $status: WaiverFormStatus) {
  waiverFormUpdate(
    group_uuid: $group_uuid
    partner_id: $partner_id
    input: $input
    status: $status
  ) {
    ...WaiverFormDetailFragment
  }
}
    ${WaiverFormDetailFragmentFragmentDoc}`;
export const WaiverFormStatusUpdateDocument = gql`
    mutation waiverFormStatusUpdate($group_uuid: String!, $partner_id: Int!, $status: WaiverFormStatus!) {
  waiverFormStatusUpdate(
    group_uuid: $group_uuid
    partner_id: $partner_id
    status: $status
  ) {
    ...WaiverFormDetailFragment
  }
}
    ${WaiverFormDetailFragmentFragmentDoc}`;
export const WaiverFormSubmissionCreateDocument = gql`
    mutation waiverFormSubmissionCreate($partner_id: Int!, $input: WaiverFormSubmissionInput!) {
  waiverFormSubmissionCreate(partner_id: $partner_id, input: $input) {
    uuid
    form_uuid
    is_test
  }
}
    `;
export const WaiverListCreateDocument = gql`
    mutation waiverListCreate($partner_id: Int!, $input: WaiverListInput!) {
  waiverListCreate(partner_id: $partner_id, input: $input) {
    ...WaiverListFragment
  }
}
    ${WaiverListFragmentFragmentDoc}`;
export const WaiverListUpdateDocument = gql`
    mutation waiverListUpdate($uuid: String!, $partner_id: Int!, $input: WaiverListInput!) {
  waiverListUpdate(uuid: $uuid, partner_id: $partner_id, input: $input) {
    ...WaiverListFragment
  }
}
    ${WaiverListFragmentFragmentDoc}`;
export const WaiverListStatusUpdateDocument = gql`
    mutation waiverListStatusUpdate($uuid: String!, $partner_id: Int!, $status: WaiverListStatus!) {
  waiverListStatusUpdate(uuid: $uuid, partner_id: $partner_id, status: $status) {
    ...WaiverListFragment
  }
}
    ${WaiverListFragmentFragmentDoc}`;
export const WaiverQuestionCreateDocument = gql`
    mutation waiverQuestionCreate($partner_id: Int!, $input: WaiverQuestionInput!) {
  waiverQuestionCreate(partner_id: $partner_id, input: $input) {
    ...WaiverQuestionFragment
  }
}
    ${WaiverQuestionFragmentFragmentDoc}`;
export const WaiverQuestionUpdateDocument = gql`
    mutation waiverQuestionUpdate($group_uuid: String!, $partner_id: Int!, $input: WaiverQuestionInput!) {
  waiverQuestionUpdate(
    group_uuid: $group_uuid
    partner_id: $partner_id
    input: $input
  ) {
    ...WaiverQuestionFragment
  }
}
    ${WaiverQuestionFragmentFragmentDoc}`;
export const WaiverQuestionStatusUpdateDocument = gql`
    mutation waiverQuestionStatusUpdate($group_uuid: String!, $partner_id: Int!, $status: WaiverQuestionStatus!) {
  waiverQuestionStatusUpdate(
    group_uuid: $group_uuid
    partner_id: $partner_id
    status: $status
  ) {
    ...WaiverQuestionFragment
  }
}
    ${WaiverQuestionFragmentFragmentDoc}`;
export const WaiverTemplateCreateDocument = gql`
    mutation waiverTemplateCreate($partner_id: Int!, $input: WaiverTemplateInput!) {
  waiverTemplateCreate(partner_id: $partner_id, input: $input) {
    ...WaiverTemplateFragment
  }
}
    ${WaiverTemplateFragmentFragmentDoc}`;
export const WaiverTemplateUpdateDocument = gql`
    mutation waiverTemplateUpdate($group_uuid: String!, $partner_id: Int!, $input: WaiverTemplateInput!) {
  waiverTemplateUpdate(
    group_uuid: $group_uuid
    partner_id: $partner_id
    input: $input
  ) {
    ...WaiverTemplateFragment
  }
}
    ${WaiverTemplateFragmentFragmentDoc}`;
export const WaiverTemplateStatusUpdateDocument = gql`
    mutation waiverTemplateStatusUpdate($group_uuid: String!, $partner_id: Int!, $status: WaiverTemplateStatus!) {
  waiverTemplateStatusUpdate(
    group_uuid: $group_uuid
    partner_id: $partner_id
    status: $status
  ) {
    ...WaiverTemplateFragment
  }
}
    ${WaiverTemplateFragmentFragmentDoc}`;
export const ZdTicketsDocument = gql`
    query zdTickets($input: ZDTicketsInput, $first: Int, $page: Int) {
  zdTickets(input: $input, first: $first, page: $page) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...ZDTicketFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${ZdTicketFragmentFragmentDoc}`;
export const ZdTicketDocument = gql`
    query zdTicket($id: Int!) {
  zdTicket(id: $id) {
    ticket {
      ...ZDTicketFragment
    }
    users {
      ...ZDUserFragment
    }
  }
}
    ${ZdTicketFragmentFragmentDoc}
${ZdUserFragmentFragmentDoc}`;
export const ZdTicketCommentsDocument = gql`
    query zdTicketComments($id: Int!, $first: Int, $page: Int) {
  zdTicketComments(id: $id, first: $first, page: $page) {
    paginatorInfo {
      ...PaginationFragment
    }
    comments {
      ...ZDTicketCommentFragment
    }
    users {
      ...ZDUserFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${ZdTicketCommentFragmentFragmentDoc}
${ZdUserFragmentFragmentDoc}`;
export const ZdTicketCreateDocument = gql`
    mutation zdTicketCreate($body: String!, $subject: String!) {
  zdTicketCreate(body: $body, subject: $subject) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const ZdTicketCommentCreateDocument = gql`
    mutation zdTicketCommentCreate($id: Int!, $body: String!) {
  zdTicketCommentCreate(id: $id, body: $body) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;